const daDK = {
  "1Minute": "1 minut",
  "1Second": "1 sekund",
  accept: "Accepter",
  acceptedDocumentsForGovernment: "Accepterede dokumenter for offentlige myndigheder",
  acceptedDocumentsForNonProfit: "Accepterede dokumenter for nonprofitorganisationer",
  acceptedDocumentsForPartnerships: "Accepterede dokumenter for partnerskaber",
  acceptedDocumentsForPrivateCompanies: "Accepterede dokumenter for private virksomheder",
  acceptedDocumentsForPublicCompanies: "Accepterede dokumenter for offentlige virksomheder",
  accountCantBeSetUp: "Din konto kan ikke konfigureres, da dine oplysninger ikke kunne bekræftes. Kontakt kundesupport for at få mere at vide.",
  accountDetailsDescription: "Angiv nogle oplysninger om dig for at begynde at acceptere livebetalinger.",
  accountHolder: "Kontoindehaver",
  accountHolderTerms: "Vilkår for kontoindehaver",
  accountName: "Kontonavn",
  accountNumber: "Kontonummer",
  accountNumberFullOrPartialVisible: "Inkluderer dit fulde eller delvise kontonummer",
  accountNumberOrIbanVisible: "Inkluderer dit kontonummer eller IBAN",
  accountNumberVisible: "Inkluderer dit kontonummer",
  accountVerification: "Kontobekræftelse",
  acknowledgePciRequirements: "Vi anerkender hermed, at vi til enhver tid skal opfylde de førnævnte krav i PCI DSS, så længe vi ønsker at modtage betalinger. Derfor skal vi løbende revurdere vores miljø og implementere eventuelle yderligere krav fra PCI DSS, hvis vores miljø ændres.",
  actionNeeded: "Handling er påkrævet",
  add: "Tilføj",
  addABankAccountForPayouts: "Føj en bankkonto til udbetalinger",
  addAccountWith: "Tilføj konto hos %{providerName}",
  addAllSourcesOfFundsBeingUsed: "Tilføj alle kilder til midler, der anvendes med de finansielle produkter, der er opført på denne side. Nogle finansieringskilder kan kræve understøttende dokumentation. ",
  addAtLeastOneInvestor: "Tilføj mindst én investor",
  addBankAccount: "Tilføj en bankkonto",
  addBankDetails: "Tilføj bankoplysninger",
  addDecisionMaker: "Tilføj beslutningstager",
  addDetailsManually: "Tilføj oplysninger manuelt",
  addDetailsManuallyQuestion: "Tilføj oplysninger manuelt?",
  addDetailsWith: "Tilføj oplysninger med",
  addDocument: "Tilføj dokument",
  addEntityOwner: "Tilføj ejeroplysninger",
  addExtraBankAccount: "Tilføj ekstra bankkonto",
  addExtraPayinAccount: "Tilføj ekstra indbetalingskonto",
  addExtraPayoutAccount: "Tilføj ekstra udbetalingskonto",
  addingAndVerifiyingABankAccount: "Tilføjelse og verificering af en bankkonto med denne metode tager typisk op til 3 hverdage.",
  addInvestor: "Tilføj investor",
  additionalInformation: "Yderligere oplysninger",
  additionalInformationFormHeading: "Yderligere virksomhedsoplysninger",
  additionalInformationFormName: "Yderligere oplysninger",
  additionalPersonalDetails: "Yderligere personlige oplysninger",
  addManually: "Tilføj manuelt",
  addMissingBankDetails: "Vi mangler dine bankoplysninger for at kunne foretage udbetalinger. Tilføj din bankkonto.",
  addOwnerToTrustMember: "Tilføj ejer af %{trustMember}",
  addPayoutAccount: "Tilføj en udbetalingskonto",
  address: "Adresse",
  address__placeHolder: "Begynd at skrive en adresse for at få forslag...",
  addresses: "Adresser",
  addressPoBoxError: "Postboksadresser er ikke tilladt. Indtast en fysisk adresse",
  addressRegisteredWithSecretaryOfState: "Adresse registreret hos myndighederne for denne virksomhed.",
  addTrustMember: "Tilføj forvaltningsmedlem",
  addYourselfAsSigner: "Tilføj dig selv som underskriver",
  adoptionCertificate: "Adoptionsattest",
  adyen: "Adyen",
  adyenKeepsDataAsLongAsLegallyRequired: "Adyen opbevarer kun dine data, så længe vi er lovmæssigt forpligtet til det. De bruges ikke til andre formål eller af andre tredjeparter end de angivne.",
  adyenPrivacyPolicy: "Adyens politik om privatlivets fred",
  adyenWillOnlyGetTemporaryAccess: "Adyen får kun midlertidig adgang til dine bankoplysninger, og dine data deles aldrig med tredjeparter.",
  agreementPeriod: "Aftaleperiode (hvis relevant)",
  aLegalRepresentativeIsRequired: "Der kræves en juridisk repræsentant",
  aLetterFromYourBank: "Et brev fra din bank",
  allCapabilitiesValid: "Alle funktioner er gyldige",
  allPayslipsFrom3MostRecentMonths: "Alle lønsedler fra de seneste 3 måneder ",
  allStatementsFrom3MostRecentMonths: "Alle kontoudtog fra de seneste 3 måneder",
  amount: "Beløb",
  amountIsRequired: "Beløb er påkrævet",
  amountWon: "Vundet beløb",
  anAssociation: "En forening",
  and: "og",
  andResubmit: "og indsend igen.",
  anLEIIsAUniqueCode: "En LEI er en unik kode, der identificerer juridiske enheder, herunder virksomheder, der deltager i finansielle transaktioner.",
  annualReport: "Årsrapport",
  annualStatements: "Årsopgørelser",
  annualTurnover: "Årlig omsætning",
  annualTurnoverHelper: "Den årlige salgsindtægt minus alle rabatter og moms. Også kendt som nettoomsætning.",
  annualTurnoverValue: "Årlig omsætning, værdi",
  aNomineeDirectorIsAppointed: "En nominel direktør udpeges til at handle i en tredjeparts interesse.",
  aNomineeShareholderHoldsShares: "En proformaaktionær holder aktier på vegne af en tredjepart.",
  anUnincorporatedPartnership: "Et partnerskab uden juridisk person",
  anyInformationFromTheUploadedDocumentWillBeLost: "Alle oplysninger fra det uploadede dokument vil gå tabt. Du skal manuelt tilføje disse data.",
  anyInformationTakenFromThisDocument: "Alle oplysninger, der tages fra dette dokument, vil blive markeret som ikke-verificerede.",
  apartmentSuite: "Lejlighed / suite",
  apartmentSuiteOther: "Lejlighed, suite, andet",
  applicationSubmittedSuccessfully: "Ansøgning blev indsendt",
  areYouACompany: "Er du en virksomhed?",
  areYouAnIndividual: "Er du en individuel person?",
  areYouSureYouWantToDeleteThisBankAccount: "Er du sikker på, at du vil slette denne bankkonto?",
  areYouSureYouWantToDeleteThisDocument: 'Er du sikker på, at du vil slette dette dokument: "%{deleteDocName}"?',
  areYouSureYouWantToDeleteThisInvestorDetails: "Er du sikker på, at du vil slette disse investoroplysninger?",
  arithmosEngraphes: "Αριθμός Εγγραφής Φ.Π.Α.",
  articlesOfIncorporation: "Stiftelsesvedtægter",
  arvonlisaveronumeroMervardesskattenummer: "Arvonlisäveronumero Mervärdesskattenummer",
  association: "Forening",
  associationIncorporated: "Forening",
  associationIncorporatedDescription: "En registreret enhed uden indtægt, der er organiseret omkring et formål som f.eks. fritid, kultur eller velgørenhed.",
  aTrust: "En forvaltning",
  australianBusinessNumberAbn: "Australian Business Number (ABN)",
  australianBusinessNumberAcn: "Australsk virksomhedsnummer (ACN)",
  back: "Tilbage",
  backPage: "Bagside",
  backToTaskList: "Tilbage til opgavelisten",
  bankAccount: "Bankkonto",
  bankAccountCountryRegion: "Land/område for bankkonto",
  bankAccountDetails: "Bankkontooplysninger",
  bankAccountFormat: "Bankkontoformat",
  bankAccountHasToBeInYourCompanyName: "Bankkontoen skal være i din virksomheds navn",
  bankAccountHasToBeInYourName: "Bankkontoen skal være i dit navn",
  bankAccountNameIndividual: "Bankkontoen skal stå i dit navn (<strong>%{individualLegalName}</strong>)",
  bankAccountNameOrganization: "Bankkontoen skal stå i din virksomheds navn (<strong>%{companyLegalName}</strong>)",
  bankAccountNameWithSoleProprietor: "Bankkontoen skal stå i dit navn (<strong>%{individualLegalName}</strong>) eller enkeltmandsvirksomhedens navn (<strong>%{soleProprietorshipName}</strong>)",
  bankAccountNameWithTrust: "Bankkontoen skal stå i din trusts navn (<strong>%{trusteeName} som administrator for %{trustLegalName}, der driver forretning som %{trustTradingName}</strong>)",
  bankAccountNameWithTrust_US: "Bankkontoen skal stå i din trusts navn (<strong>%{trusteeName} som administrator for %{trustLegalName}, der driver forretning som %{trustTradingName}</strong>)",
  bankAccountNeeded: "En bankkonto er nødvendig.",
  bankAccountNumber: "Kontonummer",
  bankAccountToHaveSameNameAsTrust: "Indehaveren af bankkontoen skal have det samme navn som din forvaltning",
  bankAccountVerification: "Bankkontobekræftelse",
  bankCityTown: "By hvor banken er beliggende",
  bankCode: "Bankkode",
  bankCountry: "Bankland/-område",
  bankDetails: "Bankoplysninger",
  bankDocument: "Bankdokument",
  bankDocumentDescription: "Vi har brug for et officielt dokument til at bekræfte dine bankkontooplysninger.",
  bankDocumentFileDescription: "Tilføj en beskrivelse af denne bankkonto (valgfrit)",
  bankDocumentHeader: "Upload et bankdokument",
  bankDocumentHeaderOptional: "Upload et bankdokument (valgfrit)",
  bankingService: "Virksomhedens bankkonti",
  bankName: "Banknavn",
  bankruptcyInsolvency: "Ja, virksomheden er ved at blive erklæret konkurs eller insolvent",
  banksLogoAndName: "Bankens logo og navn",
  bankStatement: "Kontoudtog",
  bankStatementAlreadyUploaded: "Kontoudtog er allerede blevet uploadet, er for stort, eller kontoen er allerede tilføjet. Prøv et andet",
  bankStatementDocument: "Kontoudtog",
  bankStatementIndividualDescription: "For at verificere dine bankkontooplysninger har vi brug for en kontoudskrift, der tydeligt viser dit navn og er dateret inden for de seneste 12 måneder.",
  bankStatementNonIndividualDescription: "For at verificere dine bankkontooplysninger har vi brug for en kontoudskrift, der tydeligt viser din virksomheds navn og er dateret inden for de seneste 12 måneder.",
  bankStatements: "Kontoudtog",
  basedOnTheAboveSignatory: "Med udgangspunkt i ovenstående hævder undertegnede, at oplysningerne i denne attesteringsformular repræsenterer resultaterne af vurderingen på rimelig måde.",
  basicCompanyInformation: "Grundlæggende virksomhedsoplysninger",
  basicInformation: "Grundlæggende information",
  basicInformationFormDescription: "I de næste trin indsamler og verificerer vi oplysninger om din virksomhed i overensstemmelse med den finansielle lovgivning. Læs mere om, hvordan dine data håndteres i vores",
  basicInformationFormDescriptionLink: "Erklæring om beskyttelse af personlige oplysninger.",
  basicInformationFormHeading: "Grundlæggende oplysninger om din virksomhed",
  basicInformationFormName: "Grundlæggende oplysninger",
  becauseYoureUnderXWeNeedToCollectInformationAboutALegalRepresentative: "Da du er under %{age}, er vi nødt til at indsamle oplysninger om en juridisk repræsentant i et andet trin",
  beforeSubmittingYourCapitalLoanApplication: "Før du kan få adgang til finansielle produkter, skal vi indsamle yderligere oplysninger om din virksomhed af lovgivningsmæssige årsager.",
  belowTaxThreshold: "Indtjeningen ligger under den obligatoriske tærskel for indirekte skatteregistrering i dette etableringsland/-region",
  benefactorDetails: "Oplysninger om velgører",
  benefactorsLegalName: "Velgørers fulde juridiske navn",
  benefactorsName: "Velgørers navn",
  beneficiary: "Modtager",
  beneficiaryGuideDescription: "<strong>Modtagere</strong> er de fysiske personer eller grupper af mennesker, i hvis interesse forvaltningen hovedsageligt er oprettet eller fungerer. Det kan være en enkeltperson, en juridisk enhed eller et medlem af en gruppe. Dette omfatter også &quot;udefineret modtager&quot;, som er en klasse eller gruppe af modtagere, der ikke er nævnt, men defineret på en bestemt måde i forvaltningsdokumentet.",
  bic: "BIC",
  bicSwift: "BIC / SWIFT-kode",
  birthCertificate: "Fødselsattest",
  birthDate: "Fødselsdato",
  branchCode: "Filialkode",
  branchNumber: "Filialnummer",
  brokerStatements: "Mæglererklæringer",
  browseFiles: "Gennemse filer",
  bsbCode: "Bankens filialkode (Bank State Branch, BSB)",
  bsbNumber: "BSB-nummer",
  btwNummer: "Btw-nummer",
  businessAccountDetailsDescription: "For at forberede din konto skal vi bruge oplysninger om din virksomhed.",
  businessAccountDetailsDescriptionReview: "For at sikre, at dine data er opdaterede, skal du kontrollere følgende oplysninger. Hvis det er nødvendigt, skal du redigere data, der ikke længere er korrekte.",
  businessAccountTerms: "Vilkår for virksomhedskonto",
  businessDescription: "Virksomhedsbeskrivelse",
  businessDetails: "Virksomhedsoplysninger",
  businessEarningDetails: "Andre oplysninger om virksomhedens indtjening",
  businessEntityDescription: "Dette er som regel en enkeltmandsvirksomhed, en privat virksomhed, offentlig virksomhed, partnerskab eller nonprofit.",
  businessEntityTitle: "Forretningsenhed",
  businessFinancing: "Virksomhedsfinansiering",
  businessIncorporationNumber: "Virksomhedsregistreringsnummer",
  businessInformation: "Virksomhedsoplysninger",
  businessLegalName: "Juridisk firmanavn",
  businessName: "Virksomhedsnavn",
  businessName__helperText: "Det juridiske navn bruges til at identificere en virksomhed over for myndighederne; indtast det nøjagtigt, som det står på dine offentlige eller juridiske dokumenter.",
  businessNumber: "Virksomhedsnummer",
  businessRegistrationDocument__FR: "Virksomhedsregistreringsdokument som fx et KBIS-uddrag eller situation au répertoire sirene",
  businessRegistryStatement: "Erklæring om virksomhedsregister",
  businessSelection__failedToLoad: "Virksomhedsoplysningerne kunne ikke indlæses",
  businessSelection__footer: "Kan du ikke finde din virksomhed?",
  businessSelection__footerButton: "Tilføj oplysninger manuelt",
  businessSelection__heading: "Vælg din virksomhed",
  businessSelection__invalidTin: "Denne virksomheds TIN stemmer ikke overens med dit",
  businessSelection__tinVerificationFailure: "Beklager, men noget gik galt. Prøv igen, eller fortsæt ved at trykke på Tilføj oplysninger manuelt",
  businessSelection__tinVerificationFailureModalContent: "Skatte-ID'et stemmer ikke overens med det juridiske virksomhedsnavn. Hvordan vil du fortsætte?",
  businessSelection__tinVerificationFailureModalHeader: "Virksomheden kunne ikke identificeres.",
  businessSelection__tinVerificationFailureModalPrimaryButton: "Fortsæt alligevel",
  businessSelection__tinVerificationFailureModalSecondaryButton: "Rediger oplysninger",
  businessSelection__unableToOnboardGovernmentEntity: "Vi kan desværre ikke onboarde en offentlig enhed for denne bruger.",
  businessStructure: "Forretningsstruktur",
  businessTrust: "Forretningsforvaltning",
  businessTrusteeDetails: "Virksomheds tillidshaverdetaljer",
  businessTrustEntity: "Forretningsforvaltningsenhed",
  byClickingSignIAcknowledgeAndAgree: "Ved at klikke på knappen Underskriv anerkender og accepterer jeg følgende: ",
  byClickingSubmitReview: 'Når du klikker på "Indsend gennemgang", bekræfter du, at alle dine oplysninger er gennemgået, og at alle nye eller allerede eksisterende data er korrekte og opdaterede.',
  byProceedingToTheNextStepYouConfirmThatYouHaveReadUnderstandAndAcceptTheTerms: 'Ved at gå videre til næste trin bekræfter du, at du har læst, forstået og accepteret <a href="https://onfido.com/privacy/" target="_blank" rel="noopener noreferrer nofollow">Onfidos privatlivspolitik</a> og <a href="https://onfido.com/terms-of-service/" target="_blank" rel="noopener noreferrer nofollow">Onfidos servicevilkår</a>.',
  cadastroDePessoasFisicas: "Cadastro de Pessoas Físicas (CPF)",
  cancel: "Annuller",
  canNotCompleteInstantVerification: "Kan du ikke gennemføre øjeblikkelig bekræftelse?",
  cantSetUpAcccount: "Du kan ikke oprette en konto",
  capitalUserTerms: "Vilkår for kapitalbruger",
  cardUserTerms: "Vilkår for kortbruger",
  cashManagementTrust: "Forvaltning af likviditetsstyring",
  CCIAA: "CCIAA Number",
  certificateOfFormation: "Stiftelsesdokument",
  certificateOfIncorporation: "Stiftelsesdokument",
  certificateOfIncumbency: "Bestyrelsesbevis",
  certificateOfInheritance: "Arvebevis",
  certificateOfVoterRegistration: "Bevis for vælgerregistrering",
  chamberOfCommerceExtract: "Uddrag fra handelskammeret",
  chamberOfCommerceRegistrationNumber: "Registreringsnummer i handelskammeret",
  changeYourBusinessSetup: "Vil du ændre din virksomhedsform?",
  chargeCardUserAgreement: "Brugeraftale for betalingskort",
  charitableTrust: "Velgørenhedsforvaltning",
  charityNumber: "Velgørenhedsorganisationens registreringsnummer",
  charter: "Charter",
  check: "Check",
  checkForTypos: "Tjek for skrivefejl, og prøv igen",
  chooseTheCorrectDetailsBeforeProceeding: "Vælg de korrekte oplysninger, inden du fortsætter.",
  chRegistrationNumber: "Unternehmens-Identifikationsnummer (UID)",
  city: "By",
  cityTown: "By",
  clearingCode: "Sletning af kode",
  clearingNumber: "Clearingnummer",
  close: "Luk",
  CNPJ: "CNPJ",
  code: "Kode",
  codiceFiscale: "Skattenummer",
  codiceFiscalePartitaIVA: "Codice Fiscale / Partita IVA",
  codNumericPersonal: "Cod Numeric Personal (CNP)",
  codulDeIdentificareFiscala: "Codul de identificare fiscală (CIF)",
  commercialLicence: "Handelslicens, erhvervslicens eller virksomhedslicens",
  company: "Selskab",
  companyDetails: "Virksomhedsoplysninger",
  companyFinancialInformationFormDescription: "Finansielle oplysninger",
  companyFinancialInformationFormHeading: "Finansielle oplysninger",
  companyLegalName: "Virksomheds juridiske navn",
  companyName: "Virksomhedsnavn",
  companyNumber: "Virksomhedsnummer",
  companyNumberNZ: "Virksomhedsnummer",
  companyProfile: "Virksomhedsprofil",
  companyRegistrationDocument: "Virksomhedsregistreringsdokument",
  companyRegistrationDocumentFormDescription: "Vi har brug for et officielt dokument for at bekræfte din virksomheds oplysninger.",
  companyRegistrationDocumentFormHeading: "Upload et registreringsdokument",
  companyRegistrationDocumentFormName: "Registreringsdokument",
  companyRegistrationNumber: "Virksomhedsregistreringsnummer",
  companyRegistrationNumber__HK: "Firmaets registreringsnummer (Company Registration Number, CRN)",
  companyStructure: "Virksomhedsstruktur",
  companyStructureFormDescription: "Hvilken type virksomhed har du?",
  companyStructureFormName: "Virksomhedsstruktur",
  companyTaxDocumentFormDescription: "Vi har brug for et officielt dokument for at bekræfte din virksomheds skatteoplysninger.",
  companyTaxDocumentFormHeading: "Upload et skattedokument",
  companyTaxDocumentFormName: "Skattedokument",
  companyTrustee: "Virksomheds tillidshaver",
  companyTrusteeDetails: "Virksomheds tillidshaverdetaljer",
  companyType: "Virksomhedstype",
  complete: "Færdiggør",
  completeAddingAccount: "Fuldfør tilføjelse af konto",
  confirm: "Bekræft",
  confirmationOfGrantOrSubsidy: "Bekræftelse af bevilling eller tilskud",
  confirmPersonalInformation: "Bekræft personlige oplysninger",
  constitutionalDocument: "Stiftelsesdokument",
  constitutionalDocumentHeader: "Upload et stiftelsesdokument",
  constitutionalDocumentHeaderDescription: "Dette hjælper med at bekræfte dine oplysninger.",
  constitutionalDocumentSoleProprietorshipHeaderDescription: "Det hjælper med at bekræfte oplysningerne om enkeltmandsvirksomheden.",
  constitutionalDocumentTrustHeaderDescription: "Dette hjælper med at bekræfte dine tillidsoplysninger.",
  contactDetails: "Kontaktoplysninger",
  containsNameOfCompany: "Indeholder navnet på din virksomhed eller organisation",
  "continue": "Fortsæt",
  continueCompany: "Fortsæt som virksomhed",
  continueIndividual: "Fortsæt som individ",
  contractSpecifyingDividends: "Kontrakt med udspecificering af udbytte",
  contributionBelowThreshold: "Min stifters væsentlige aktivbidrag til forvaltningen var mindre end 10.000 AUD på tidspunktet for dens oprettelse",
  controllingPerson: "Kontrollerende person",
  controllingPersonDescription: "Bemyndiget til at træffe vigtige forretningsmæssige beslutninger (kan være ejer eller ej)",
  controllingPersonGuideDescription: "En <strong>kontrollerende person</strong> er en person, der er bemyndiget til at træffe vigtige forretningsmæssige beslutninger. De er måske eller måske ikke ejere.",
  corporateUnitTrust: "Forvaltning af virksomhedsenhed",
  correctErrorsResubmit: "Ret følgende fejl, og indsend formularen igen",
  couldNotCompleteAccountCheck: "Vi kunne ikke fuldføre kontokontrollen",
  couldNotEstablishBankConnection: "Vi kunne ikke oprette forbindelse til din bank",
  country: "Land-/område",
  country__US__business: "Hvor er din virksomhed registreret?",
  countryOfGoverningLaw: "Land/region for gældende lovgivning",
  countryRegionOfEstablishment: "Etableringsland/-område",
  countryWithoutVatOrGstSystem: "Der er ingen indirekte skat i dette etableringsland/region",
  courtOrder: "Retskendelse",
  cryptocurrencyExchange: "Kryptovalutabørs",
  cryptocurrencyIncome: "kryptovalutaindtægt",
  cryptocurrencyProceedDetails: "Detaljer om kryptovalutaindtægter",
  currency: "Valuta",
  currencyCode: "Valutakode",
  currencyIsRequired: "Valuta er påkrævet",
  currencyPlaceholder: "Vælg en valutakode",
  customerSupport: "Kundesupport",
  "CVR-nummer": "CVR-nummer",
  cyRegistrationNumber: "Αριθμός Εγγραφής",
  dataMissingError: "Vi mangler påkrævede data.",
  dataReviewNeeded: "En gennemgang af data er nødvendig.",
  date: "Dato",
  dateCannotBeInTheFuture: "Dato må ikke være i fremtiden",
  datedInTheLastXMonths: "Dateret inden for de seneste %{number} måneder",
  dateOfIncorporation: "Stiftelsesdato",
  dateOfSale: "Salgsdato",
  dateOfSourceEvent: "Dato for kildehændelse",
  dateOfTotalAssetsCalculation: "Den dato, hvor de samlede aktiver og den årlige omsætning blev beregnet, er ofte balancedatoen.",
  dateOfWinning: "Dato for gevinst",
  dateOfWinnings: "Dato for gevinst",
  dateOnDocumentNoOlderThanXMonths: "Dato på dokumentet er ikke ældre end %{numberOfMonths} måneder",
  datePlaceholder: "dd/mm/åååå",
  dbaName: "Binavn",
  deceased: "Min stifter er afgået ved døden",
  deceasedEstate: "Dødsbo",
  decedentsCountryOfDeath: "Afdødes land/område, hvor døden indtraf",
  decedentsLegalFirstName: "Afdødes juridiske fornavn",
  decedentsLegalLastName: "Afdødes juridiske efternavn",
  decedentsName: "Afdødes navn",
  decisionMaker: "Beslutningstagere",
  decisionMakerDescription: "Angiv oplysninger om ejerne, de kontrollerende personer og underskriverne i din virksomhed. Husk, at én person kan have flere roller. Kravene er som følger:",
  decisionMakers: "Beslutningstagere",
  definedBeneficiary: "Defineret modtager",
  definedBeneficiaryDescription: "En fysisk person, en virksomhed eller et medlem af en gruppe, i hvis interesse forvaltningen hovedsageligt er oprettet eller fungerer.",
  "delete": "Slet",
  deleteDocument: "Slet dokumentet",
  deleteIdDocument: "Slet ID-dokument?",
  deleteInvestorDetails: "Slet investoroplysninger",
  depositSlip: "Indbetalingsseddel",
  describeWhoIsABeneficiaryInYourTrust: "Beskriv i åbent format, hvem der er indstillet til at være modtagere i dit forvaltningsdokument.",
  description: "Beskrivelse",
  descriptionOfIntellectualProperty: "Beskrivelse af (intellektuel) ejendom",
  descriptionOfProperty: "Beskrivelse af ejendom",
  descriptionOptional: "Beskrivelse (valgfri)",
  descriptionUndefinedBeneficiary: "Udefineret beskrivelse af modtager",
  detCentralePersonregister: "Det Centrale Personregister (CPR)",
  detected: "Registreret",
  DIC: "Daňové identifikační číslo (DIČ)",
  director: "Direktør",
  directorDescription: "En person, der er udpeget til at administrere en virksomheds forretninger og anliggender",
  directorGuideDescription: "En <strong>direktør</strong> er en person, der er udpeget til at administrere en virksomheds forretninger og anliggender. Dine direktører kan findes i virksomhedsregisteret/virksomhedsregistreringen.",
  discretionaryInvestmentTrust: "Forvaltning af diskretionære investeringer",
  discretionaryServicesManagementTrust: "Forvaltning af diskretionære tjenesteydelser",
  discretionaryTradingTrust: "Forvaltning af diskretionær handel",
  discretionaryTrust: "Diskretionær forvaltning",
  dividendAmount: "Udbyttebeløb",
  dni: "DNI",
  documentAddressedToName: "Dokumentet skal adresseres til %{name}",
  documentCannotBeDamaged: "Dokumentet kan ikke beskadiges",
  documentDeletedSuccessfully: "Dokumentet blev slettet",
  documentIssuedByGovernmentAuthority: "Dokumentet skal være udstedt af en offentlig myndighed. Det udstedes normalt, når en virksomhed oprettes i det lokale handelsregister",
  documentName: "Dokumentnavn",
  documentNotExpiredOrDamaged: "Dokumentet må ikke være udløbet eller beskadiget",
  documentRequirements: "Dokumentkrav",
  documents: "Dokumenter",
  documentShouldShow: "Dokumentet skal vise",
  documentShowsTaxIdOfCompany: "Dokumentet viser virksomhedens skatte-ID-nummer",
  documentType: "Dokumenttype",
  documentUpload: "Dokumentupload",
  documentUploadedSuccessfully: "Dokumentet blev uploadet",
  documentVerification: "Dokumentbekræftelse",
  doesThisCompanyHaveLEI: "Har denne virksomhed en Legal Entity Identifier (LEI-kode)?",
  doesYourCompanyHaveLEI: "Har din virksomhed en Legal Entity Identifier (LEI-kode)?",
  doingBusinessAs: "Driver virksomhed under navnet",
  doingBusinessAsNameFiling: "Indgivelse af Driver virksomhed under navnet (DBA)",
  doingBusinessAsNameFiling__FR: "Indgivelse af handelsnavn",
  doingBusinessAsNameFiling__US: "Indgivelse af en Driver virksomhed under navnet (DBA), f.eks. dine stiftelsesdokumenter",
  donorsCountryOfResidence: "Donors bopælsland/-område",
  donorsLegalFirstName: "Donors juridiske fornavn",
  donorsLegalLastName: "Donors juridiske efternavn",
  donorsName: "Donors navn",
  doNotHaveAbn: "Jeg har ikke et ABN",
  doNotHaveAcn: "Jeg har ikke et ACN",
  doNotHaveBusinessIncorporationNumber: "Jeg har ikke et virksomhedsregistreringsnummer",
  doNotHaveBusinessNumber: "Jeg har ikke et virksomhedsnummer",
  doNotHaveChRegistrationNumber: "Jeg har ikke et Unternehmens-Identifikationsnummer (UID)",
  doNotHaveEIN: "Jeg har ikke et EIN",
  doNotHaveFirmenbuchnummer: "Jeg har ikke et Firmenbuchnummer",
  doNotHaveHandelsregisternummer: "Jeg har ikke et handelsregisternummer",
  doNotHaveLtRegistrationNumber: "Jeg har ikke Įmonės kodas",
  doNotHaveLuRegistrationNumber: "Jeg har ikke et numéro registre de commerce et des sociétés (RCS)",
  doNotHaveNZBN: "Jeg har ikke et NZBN",
  doNotHaveOrganisationsnummer: "Jeg har ikke et organisationsnummer",
  doNotHaveRegonKrsNumber: "Jeg har ikke et REGON",
  doNotHaveYTunnus: "Jeg har ikke Y-TUNNUS",
  download: "Download",
  downloadACopy: "Download en kopi",
  downloadAsPdf: "Download som PDF",
  driversLicense: "Kørekort",
  driving_licence: "Kørekort",
  drivinglicenseBack: "Kørekort (bagside)",
  drivinglicenseFront: "Kørekort (forside)",
  dropFileToUpload: "Slip fil for at uploade",
  duplicatedFiles: "Duplikerede filer",
  edit: "Rediger",
  editDetails: "Rediger oplysninger",
  editEntityDetails: "Rediger enhedsoplysninger",
  editEntityOwner: "Rediger ejeroplysninger",
  editOwnerOfTrustMember: "Rediger ejer af %{trustMember}",
  editTrustMember: "Rediger detaljer for %{trustMember} ",
  ein: "EIN",
  einVerificationLetter: "Bekræftelsesbrev til Employer identification number (EIN), også kendt som et CP 575- eller 147c-brev",
  eInvoicingCode: "Kode for e-fakturering (SDI)",
  email: "E-mailadresse",
  employersName: "Arbejdsgivers navn",
  enter1LetterAndThenNDigitsForExample: "Indtast 1 bogstav og derefter %{numDigits} cifre. For eksempel %{example}",
  enter1LetterAndThenXToYDigitsForExample: "Indtast 1 bogstav og derefter %{minDigits} til %{maxDigits} cifre. For eksempel %{example}",
  enterAMaximumOfNCharactersForExample: "Indtast maksimalt %{maxChars} tegn. For eksempel %{example}",
  enterAMaximumOfNCharactersWithAMixForExample: "Indtast maksimalt %{maxChars} tegn med en blanding af bogstaver og tal. For eksempel %{example}",
  enterAMaximumOfNDigitsForExample: "Indtast maksimalt %{maxDigits} cifre. For eksempel %{example}",
  enterAMaximumOfNMoreDigitsForExample: "Indtast maksimalt %{maxDigits} cifre mere. For eksempel %{example}",
  enterEnglishLetterFollowedByXtoYDigitsForExample: "Indtast et bogstav svarende til engelsk (C for HE, O for AE, P for Σ) efterfulgt af %{minDigits} - %{maxDigits} cifre. For eksempel %{example}",
  enterLastNameExactlyAsAppearInID: "Angiv efternavne nøjagtigt som skrevet på dit identitetsdokument",
  enterLastNDigitsForExample: "Indtast de sidste %{numDigits} cifre. For eksempel %{example}",
  enterNameExactlyAsAppearInID: "Angiv fornavne nøjagtigt som skrevet på dit identitetsdokument",
  enterNCharactersForExample: "Indtast %{numChars} tegn. For eksempel %{example}",
  enterNCharactersWithAMixForExample: "Indtast %{numChars} tegn med en blanding af bogstaver og tal. For eksempel %{example}",
  enterNDigitsAndThen1LetterForExample: "Indtast %{numDigits} cifre og derefter 1 bogstav. For eksempel %{example}",
  enterNDigitsForExample: "Indtast %{numDigits} cifre. For eksempel %{example}",
  enterNLetterPrefixOptionallyAndThenXToYDigitsForExample: "Angiv %{minDigits} eller %{maxDigits} cifre med eller uden et præfiks på %{numChars} bogstaver. For eksempel, %{example1} eller %{example2}",
  enterNLettersAndThenXToYDigitsForExample: "Indtast %{numLetters} bogstaver og derefter %{minDigits} til %{maxDigits} cifre. For eksempel %{example}",
  enterpriseNumber: "Virksomhedsnummer",
  enterSettlorsFirstNameExactlyAsItAppearsInID: "Indtast stifterens fornavne nøjagtigt som det står på deres identitetsdokument.",
  enterSettlorsLastNameExactlyAsItAppearsInID: "Indtast stifterens efternavne nøjagtigt som det står på deres identitetsdokument.",
  enterTheDetailsYourself: "Indtast selv oplysningerne",
  enterTheRemainingNCharactersForExample: "Indtast de resterende %{numChars} tegn. For eksempel %{example}",
  enterTheRemainingNDigitsForExample: "Indtast de resterende %{numDigits} cifre. For eksempel %{example}",
  enterTheRemainingNDigitsThenXToYLettersForExample: "Indtast de resterende %{numDigits} cifre og derefter %{minLetters} til %{maxLetters} bogstaver. For eksempel %{example}",
  enterTheRemainingXToYCharactersForExample: "Indtast de resterende %{minChars} til %{maxChars} tegn. For eksempel %{example}",
  enterTheRemainingXToYDigitsForExample: "Indtast de resterende %{minDigits} til %{maxDigits} cifre. For eksempel %{example}",
  enterValid_: "Indtast gyldig: %{fieldNames}",
  enterValidAccountDetails: "Indtast gyldige kontooplysninger",
  enterXOrYCharactersForExample: "Indtast %{xChars} eller %{yChars} tegn. For eksempel %{example}",
  enterXOrYDigitsForExample: "Indtast %{xDigits} eller %{yDigits} cifre. For eksempel %{example}",
  enterXToYCharactersForExample: "Indtast %{minChars} til %{maxChars} tegn. For eksempel %{example}",
  enterXToYCharactersWithAMixForExample: "Indtast %{minChars} til %{maxChars} tegn med en blanding af bogstaver og tal. For eksempel %{example}",
  enterXToYDigitsForExample: "Indtast %{minDigits} til %{maxDigits} cifre. For eksempel %{example}",
  entityEstablishingTrust: "Den enhed, der etablerer en forvaltning.",
  entityType: "Enhedstype",
  errorMessage_1_10: "Oplysningerne kunne ikke bekræftes",
  errorMessage_1_11: "Dokumentet opfyldte ikke kravene",
  errorMessage_1_12: "Juridisk enhed er afvist",
  errorMessage_1_30: "Individuelle oplysninger kunne ikke bekræftes",
  errorMessage_1_31: "ID-dokument er nødvendigt",
  errorMessage_1_32: "ID-dokumentet kunne ikke behandles",
  errorMessage_1_33: "ID-dokumentet opfyldte ikke kravene",
  errorMessage_1_34: "Billedet af ID-dokumentet opfyldte ikke kravene",
  errorMessage_1_35: "Individuelle oplysninger stemte ikke overens med id-dokumentet",
  errorMessage_1_36: "Bevis for bopæl opfyldte ikke kravene",
  errorMessage_1_37: "Billedet af bevis for bopæl opfyldte ikke kravene",
  errorMessage_1_38: "Individuelle oplysninger stemte ikke overens med beviset for bopæl",
  errorMessage_1_39: "Bevis for nationalt id-nummer opfyldte ikke kravene",
  errorMessage_1_40: "Billedet af beviset på nationalt id-nummer opfyldte ikke kravene",
  errorMessage_1_41: "Individuelle oplysninger stemte ikke overens med beviset på nationalt ID-nummer",
  errorMessage_1_50: "Virksomhedsoplysningerne kunne ikke bekræftes",
  errorMessage_1_51: "Organisationsoplysningerne stemmer ikke overens med dokumentet",
  errorMessage_1_52: "Registreringsdokumentet opfyldte ikke kravene",
  errorMessage_1_53: "Skattedokumentet opfyldte ikke kravene",
  errorMessage_1_54: "Bevis for adresse opfyldte ikke kravene",
  errorMessage_1_55: "Bevis for ejerskab er nødvendigt",
  errorMessage_1_56: "Organisationsejerskab kunne ikke bekræftes",
  errorMessage_1_57: "Det indsendte tilknytningsdokument opfyldte ikke kravene",
  errorMessage_1_58: "Momsdokumentet opfyldte ikke kravene",
  errorMessage_1_60: "Oplysninger om juridisk enhed kunne ikke bekræftes",
  errorMessage_1_61: "Stiftelsesdokumentet opfyldte ikke kravene",
  errorMessage_1_62: "Oplysninger om den juridiske enhed stemte ikke overens med stiftelsesdokumentet",
  errorMessage_1_70: "Bankkonto kunne ikke bekræftes",
  errorMessage_1_71: "Bankkontooplysningerne kunne ikke bekræftes",
  errorMessage_1_72: "Bekræftelsen kunne ikke fuldføres",
  errorMessage_1_73: "Adgang til bankkonto kunne ikke godkendes",
  errorMessage_1_74: "Kontoudtog er nødvendigt",
  errorMessage_1_75: "Kontoudtoget opfyldte ikke kravene",
  errorMessage_1_76: "Bankoplysningerne stemte ikke overens med kontoudtoget",
  errorMessage_1_84: "Bestyrelsesmedlemsbevis mangler",
  errorMessage_1_85: "Bestyrelsesmedlemsbevis opfyldte ikke kravene",
  errorMessage_1_86: "Direktøroplysninger stemte ikke overens med bestyrelsesmedlemsbevis",
  errorMessage_1_87: "Direktøroplysningerne kunne ikke bekræftes",
  errorMessage_1_93: "Oplysninger om kilde til midler kunne ikke bekræftes",
  errorMessage_1_94: "Dokumentation for finansiering opfyldte ikke kravene",
  errorMessage_1_803: "Upload et bevis på direktør-dokument til juridisk enhed",
  errorMessage_1_804: "Upload et andet bestyrelsesmedlemsbevis",
  errorMessage_1_1000: "Bekræftelsen mislykkedes. Juridisk enhed er afvist",
  errorMessage_1_1001: "Der opstod tekniske problemer i forbindelse med bekræftelsesprocessen.",
  errorMessage_1_1002: "Der er flere spørgsmål om de indsendte oplysninger.",
  errorMessage_1_1003: "Dokumentet indeholdt følsomme data.",
  errorMessage_1_3000: "Brugeren kunne ikke bekræftes.",
  errorMessage_1_3001: "Navnet og fødselsdatoen kunne ikke bekræftes.",
  errorMessage_1_3002: "Navnet og det nationale ID-nummer kunne ikke bekræftes.",
  errorMessage_1_3003: "Navnet og bopælsstaten kunne ikke bekræftes.",
  errorMessage_1_3004: "Navnet og bopælslandet kunne ikke bekræftes.",
  errorMessage_1_3005: "Det nationale ID-nummer blev indtastet forkert.",
  errorMessage_1_3006: "Navnet stemmer ikke overens med ikke det nationale ID-nummer.",
  errorMessage_1_3007: "Det nationale ID-nummer blev indtastet forkert.",
  errorMessage_1_3008: "Billedet af ID-dokumentet var ufuldstændigt.",
  errorMessage_1_3009: "Billedet på ID-dokumentet kunne ikke genkendes.",
  errorMessage_1_3010: "Billedet af ID-dokumentet var ufuldstændigt eller for sløret.",
  errorMessage_1_3011: "Billedet af ID-dokumentet var i sort-hvid.",
  errorMessage_1_3012: "Billedet kunne ikke genkendes som et understøttet ID-dokument.",
  errorMessage_1_3013: "ID-dokumentet var ikke en understøttet dokumenttype.",
  errorMessage_1_3014: "Billedet af ID-dokumentet indeholdt ikke MRZ-koden.",
  errorMessage_1_3015: "ID-dokumentet er udløbet.",
  errorMessage_1_3016: "Billedet af ID-dokumentet var af for lav kvalitet.",
  errorMessage_1_3017: "Billedet af ID-dokumentet var en scanning.",
  errorMessage_1_3018: "Billedet af ID-dokumentet var for sløret.",
  errorMessage_1_3019: "ID-dokumentet er udløbet.",
  errorMessage_1_3020: "ID-dokumentet var ikke en understøttet dokumenttype.",
  errorMessage_1_3021: "ID-dokumentets MRZ-kode er ulæselig.",
  errorMessage_1_3022: "Billedet af ID-dokumentet viste kun den ene side af ID-dokumentet.",
  errorMessage_1_3023: "Billedet af ID-dokumentet viste kun dele af ID-dokumentet.",
  errorMessage_1_3024: "ID-dokumentet var ikke gyldigt.",
  errorMessage_1_3025: "Staten matchede ikke den på ID-dokumentet.",
  errorMessage_1_3026: "ID-dokumentet viste ikke en udstedende stat.",
  errorMessage_1_3027: "ID-dokumentet var ikke gyldigt.",
  errorMessage_1_3028: "ID-nummeret stemmer ikke overens med det i dokumentet.",
  errorMessage_1_3029: "ID-dokumentet viste ikke et dokumentnummer.",
  errorMessage_1_3030: "ID-dokumentet var ikke gyldigt.",
  errorMessage_1_3031: "ID-dokumentet var ikke gyldigt.",
  errorMessage_1_3032: "Fornavnet matchede ikke navnet på ID-dokumentet.",
  errorMessage_1_3033: "Efternavnet matchede ikke navnet på ID-dokumentet.",
  errorMessage_1_3034: "Fødselsdatoen stemte ikke overens med datoen på ID-dokumentet.",
  errorMessage_1_3035: "Landet matchede ikke det på ID-dokumentet.",
  errorMessage_1_3036: "Billedet af ID-dokumentet var for lav kvalitet.",
  errorMessage_1_3037: "Efternavnet stemmer ikke overens med det, der stod på beviset for bopælsadressen.",
  errorMessage_1_3038: "Fornavnet stemmer ikke overens med det, der stod på beviset for bopælsadressen.",
  errorMessage_1_3039: "Fødselsdatoen stemmer ikke overens med den, der stod på beviset for bopælsadressen.",
  errorMessage_1_3040: "Beviset for bopælsadresse viste ikke den dato, hvor det blev udstedt.",
  errorMessage_1_3041: "Beviset for bopælsadressen viste ikke et navn.",
  errorMessage_1_3042: "Beviset for bopælsadresse viste ikke noget udstedende land.",
  errorMessage_1_3043: "Bevis for bopælsadresse var ikke en understøttet dokumenttype.",
  errorMessage_1_3044: "Beviset for bopælsadressen var for gammelt.",
  errorMessage_1_3045: "Billedet af beviset for bopælsadresse var af for dårlig kvalitet.",
  errorMessage_1_3046: "Adressen på beviset for bopælsadressen var en postboks.",
  errorMessage_1_3047: "Beviset på nationalt ID-nummer var ikke en understøttet dokumenttype.",
  errorMessage_1_3048: "Efternavnet stemmer ikke overens med det, der stod på beviset på nationalt ID-nummer.",
  errorMessage_1_3049: "Fornavnet stemmer ikke overens med det, der stod på beviset for nationalt id-nummer.",
  errorMessage_1_3050: "Fødselsdatoen stemmer ikke overens med det, der stod på beviset på nationalt ID-nummer.",
  errorMessage_1_3051: "Billedet af beviset på nationalt ID-nummer var af for dårlig kvalitet.",
  errorMessage_1_3052: "Et ID-dokument er nødvendigt for at bekræfte den enkelte.",
  errorMessage_1_3062: "Navnet og det 4-cifrede SSN kunne ikke bekræftes.",
  errorMessage_1_3072: "Vi fandt følgende problemer:\n - Navnet og nationaliteten kunne ikke bekræftes.\nGennemgå oplysningerne nedenfor, og ret eventuelle fejl, eller upload et ID-dokument, og indsend det igen.",
  errorMessage_1_3073: "Vi fandt følgende problemer:\n- ID-dokumentet viste ikke nationaliteten.\nGennemgå oplysningerne nedenfor, og ret eventuelle fejl, eller upload et ID-dokument, og indsend det igen.",
  errorMessage_1_3083: "Individuelle oplysninger stemte ikke overens med id-dokumentet",
  errorMessage_1_5000: "Det juridiske virksomhedsnavn kunne ikke bekræftes.",
  errorMessage_1_5001: "Skatte-ID-nummeret kunne ikke bekræftes.",
  errorMessage_1_5002: "Staten kunne ikke bekræftes.",
  errorMessage_1_5003: "Det juridiske navn stemmer ikke overens med det i registeret.",
  errorMessage_1_5004: "Det juridiske navn stemmer ikke overens med det i registeret.",
  errorMessage_1_5005: "Det juridiske navn stemmer ikke overens med det i registeret.",
  errorMessage_1_5006: "Landet stemmer ikke overens med det i registeret.",
  errorMessage_1_5007: "Registreringsnummeret stemmer ikke overens med det i registeret.",
  errorMessage_1_5008: "Skatte-ID'et stemmer ikke overens med det i registeret.",
  errorMessage_1_5009: "Registreringsnummeret blev angivet som skatte-ID.",
  errorMessage_1_5010: "Virksomhedsoplysningerne kunne ikke bekræftes. ",
  errorMessage_1_5011: "Handelsnavnet (driver forretning som) blev indtastet.",
  errorMessage_1_5012: "Den indsendte virksomhedstype stemmer ikke overens med den i registeret.",
  errorMessage_1_5013: "Virksomheden blev ikke fundet i databasen.",
  errorMessage_1_5014: "Registreringsnummeret kunne ikke bekræftes. ",
  errorMessage_1_5015: "Registreringsnummeret stemmer ikke overens med det juridiske virksomhedsnavn.",
  errorMessage_1_5016: "Skatte-ID-nummeret kunne ikke bekræftes.",
  errorMessage_1_5017: "Skatte-ID-nummeret stemmer ikke overens med det juridiske virksomhedsnavn.",
  errorMessage_1_5018: "Virksomhedens skatte-ID kunne ikke bekræftes.",
  errorMessage_1_5019: "Handelsnavnet (driver forretning som) blev angivet i stedet for det juridiske navn.",
  errorMessage_1_5020: "Der mangler et registreringsdokument.",
  errorMessage_1_5021: "Registreringsdokumentet var af for lav kvalitet.",
  errorMessage_1_5022: "Registreringsdokumentet var for gammelt.",
  errorMessage_1_5023: "Den indsendte virksomhedstype stemmer ikke overens med den, der stod i registreringsdokumentet.",
  errorMessage_1_5024: "Registreringsdokumentet viste ikke virksomhedstypen.",
  errorMessage_1_5025: "Adressen på virksomhedsregistreringsdokumentet var en privat adresse.",
  errorMessage_1_5026: "Adressen på virksomhedsregistreringsdokument var en postboks.",
  errorMessage_1_5027: "Virksomhedsadressen stemmer ikke overens med adressen på virksomhedsregistreringsdokumentet.",
  errorMessage_1_5028: "Registreringsnummeret stemmer ikke overens med det, der stod i registreringsdokumentet.",
  errorMessage_1_5029: "Det juridiske virksomhedsnavn stemmer ikke overens med det, der stod i virksomhedsregistreringsdokumentet.",
  errorMessage_1_5030: "Landet stemmer ikke overens med den, der stod på virksomhedsregistreringsdokumentet.",
  errorMessage_1_5031: "Virksomhedsregistreringsdokumentet viste ikke et lovligt virksomhedsnavn.",
  errorMessage_1_5032: "Virksomhedsregistreringsdokumentet viste ikke noget registreringsnummer.",
  errorMessage_1_5033: "Staten stemte ikke overens med den, der stod på virksomhedsregistreringsdokumentet.",
  errorMessage_1_5034: "Registreringsdokumentet var ikke en dokumenttype, der blev understøttet.",
  errorMessage_1_5035: "Virksomhedsregistreringsdokumentet understøttes ikke.",
  errorMessage_1_5036: "Der mangler et skattedokument.",
  errorMessage_1_5037: "Landet stemmer ikke overens det med på skattedokumentet.",
  errorMessage_1_5038: "Bankdokumentet var ikke en understøttet dokumenttype.",
  errorMessage_1_5039: "Bankdokumentets kvalitet var ikke god nok.",
  errorMessage_1_5040: "Bankdokumentet var for gammelt.",
  errorMessage_1_5041: "Efternavnet stemmer ikke overens det med navnet på ID-dokumentet.",
  errorMessage_1_5042: "Skatte-ID-nummeret stemmer ikke overens med det juridiske virksomhedsnavn.",
  errorMessage_1_5043: "Skattedokumentet viste ikke et skatte-ID-nummer.",
  errorMessage_1_5044: "Skattedokumentet viste ikke et lovligt firmanavn.",
  errorMessage_1_5045: "Staten stemmer ikke overens med den på beviset for adresse.",
  errorMessage_1_5046: "Data om ejerskab ser ud til at være forkerte.",
  errorMessage_1_5047: "Data om ejerskab ser ud til at mangle.",
  errorMessage_1_5048: "Angiv officiel ejerskabsdokumentation.",
  errorMessage_1_5049: "Tilknytningsdokumentet var ikke tilstrækkeligt til at bevise, at der var tale om 100 % tilknytning.",
  errorMessage_1_5050: "Tilknytningsdokumentet var ikke officielt.",
  errorMessage_1_5051: "Person, der har underskrevet tilknytningsdokumentet, kunne ikke bekræftes",
  errorMessage_1_5052: "Tilknytningsdokumentet bekræfter, at udbetalingsenheden ikke er 100 % tilknyttet virksomheden. Konfigurationen kan ikke fortsættes.",
  errorMessage_1_5053: "Tilknytningsdokumentet er ikke udstedt inden for de seneste 6 måneder",
  errorMessage_1_5054: "Momsnummeret kunne ikke bekræftes",
  errorMessage_1_5055: "Momsdokumentet mangler",
  errorMessage_1_5057: "Momsdokumentet var ikke en understøttet dokumenttype",
  errorMessage_1_5067: "Det juridiske navn stemmer ikke overens med det i momsregisteret.",
  errorMessage_1_6000: "Det juridiske navn kunne ikke bekræftes.",
  errorMessage_1_6001: "Det juridiske navn matchede ikke registreringsnummeret.",
  errorMessage_1_6002: "Registreringsnummeret kunne ikke bekræftes.",
  errorMessage_1_6003: "Den juridiske enhedstype kunne ikke bekræftes.",
  errorMessage_1_6004: "Det land, hvor lovgivningen var gældende, kunne ikke bekræftes.",
  errorMessage_1_6005: "Der mangler et stiftelsesdokument.",
  errorMessage_1_6006: "Stiftelsesdokumentetet var for gammelt.",
  errorMessage_1_6007: "Det juridiske navn matchede ikke stiftelsesdokumentet.",
  errorMessage_1_6008: "Landet, hvor lovgivningen var gældende, stemte ikke overens med stiftelsesdokumentet.",
  errorMessage_1_6009: "Stiftelsesdokumentet viste ikke et juridisk navn.",
  errorMessage_1_6010: "Stiftelsesdokumentet viste ikke et registreringsnummer.",
  errorMessage_1_6011: "Den juridiske enhedstype stemte ikke overens med den, der var angivet i stiftelsesdokumentet.",
  errorMessage_1_6012: "Den juridiske enheds stat stemte ikke overens med den, der var angivet i stiftelsesdokumentet.",
  errorMessage_1_6013: "Den registrerede stat kunne ikke bekræftes.",
  errorMessage_1_6014: "Den indsendte registrerede stat stemte ikke overens med den i registret.",
  errorMessage_1_6015: "Stiftelsesdokumentet indeholdt følsomme data.",
  errorMessage_1_6016: "Stiftelsesdokumentet understøttes ikke.",
  errorMessage_1_6017: "Stiftelsesdokumentet hører ikke til den juridiske ordning.",
  errorMessage_1_6018: "Juridisk enhed blev ikke fundet.",
  errorMessage_1_6019: "Stiftelsesdokumentet viste ikke datoen for udstedelse.",
  errorMessage_1_6020: "Stiftelsesdokumentet viste ikke et stempel/underskrift.",
  errorMessage_1_6021: "Billedkvaliteten af stiftelsesdokumentet var for lav.",
  errorMessage_1_6022: "Registreringsnummeret stemmer ikke overens med det i registeret.",
  errorMessage_1_6023: "Det juridiske enheds navn stemmer ikke overens med det i registeret.",
  errorMessage_1_6024: "Handelsnavnet (driver forretning som) blev angivet i stedet for det juridiske navn for enheden.",
  errorMessage_1_6025: "Navnet på den juridiske enhed er forkert.",
  errorMessage_1_6026: "Den juridiske enheds registreringsnummer stemte ikke overens med det, der var angivet i stiftelsesdokumentet.",
  errorMessage_1_6027: "Den registrerede enhedstype er anderledes",
  errorMessage_1_6028: "Stiftelsesdokumentet er ikke forbundet med en juridisk ordning.",
  errorMessage_1_6029: "Stiftelsesdokumentet viste ikke et stempel/underskrift.",
  errorMessage_1_6030: "Stiftelsesdokumentet viste ikke oplysninger om stifteren/stifterne.",
  errorMessage_1_6031: "Stiftelsesdokumentet viste ikke oplysninger om protektor/protektorerne.",
  errorMessage_1_6032: "Stiftelsesdokumentet viste ikke detaljerne i de definerede modtagere.",
  errorMessage_1_6033: "Stiftelsesdokumentet viste ikke detaljerne om de udefinerede modtagere.",
  errorMessage_1_6034: "Oplysningerne om den sekundære tillidshaver stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6035: "Oplysningerne om stifterne stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6036: "Oplysningerne om protektorerne stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6037: "Oplysningerne om de definerede modtagere stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6038: "Oplysningerne om de udefinerede modtagere stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6039: "Den sekundære tillidshaver mangler.",
  errorMessage_1_6040: "Protektorerne mangler.",
  errorMessage_1_6041: "De sekundære tillidshavere er en fysisk person, men i stedet nævnes en organisation.",
  errorMessage_1_6042: "De sekundære tillidshavere er en organisation, men i stedet nævnes en fysisk person.",
  errorMessage_1_6044: "Stiftelsesdokumentet viste ikke oplysningerne om de sekundære tillidshavere.",
  errorMessage_1_6045: "Stiftelsesdokumentet viste ikke oplysninger om UBO'er.",
  errorMessage_1_6046: "Oplysningerne om de sekundære partnere stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6047: "Oplysningerne om UBO'er stemte ikke overens med dem i stiftelsesdokumentet.",
  errorMessage_1_6048: "De sekundære partnere er en fysisk person, men i stedet nævnes en organisation.",
  errorMessage_1_6049: "De sekundære partnere er en organisation, men i stedet nævnes en fysisk person.",
  errorMessage_1_7000: "Bankkontoen kunne ikke bekræftes.",
  errorMessage_1_7001: "Routingnummeret var ugyldigt.",
  errorMessage_1_7002: "Bankkontonummeret er ugyldigt.",
  errorMessage_1_7003: "Bankkontoen kunne ikke bekræftes.",
  errorMessage_1_7004: "Den indtastede bankkonto var ugyldig.",
  errorMessage_1_7005: "Bekræftelseskoden var ugyldig.",
  errorMessage_1_7006: "Der var for mange forsøg på at anmode om bekræftelseskoden.",
  errorMessage_1_7007: "Bekræftelseskoden blev ikke indtastet.",
  errorMessage_1_7008: "Der er ikke noget bankdokument at bekræfte.",
  errorMessage_1_7009: "Bankdokumentet viste ikke et bankkontonummer.",
  errorMessage_1_7010: "Bankdokumentet viste ikke kontoejerens navn.",
  errorMessage_1_7011: "Bankkontonummeret stemte ikke overens med nummeret på bankdokumentet.",
  errorMessage_1_7012: "Bankkontoejerens navn i dokumentet svarer ikke til det bekræftede juridiske navn.",
  errorMessage_1_7013: "Bankdokumentets kvalitet var for dårligt.",
  errorMessage_1_7014: "Bankdokumentet var ikke en understøttet dokumenttype.",
  errorMessage_1_7015: "Bankkontolandet stemte ikke overens med landet på bankdokumentet.",
  errorMessage_1_7016: "Filialkoden stemmer ikke overens med den, der stod på bankdokumentet.",
  errorMessage_1_7017: "Landet for bankkontoen stemte ikke overens med det på bankdokumentet.",
  errorMessage_1_7018: "Bankdokumentet var ikke officielt udstedt af banken.",
  errorMessage_1_7019: "Bankdokumentet er ikke udstedt inden for de seneste 12 måneder.",
  errorMessage_1_7020: "Banknavnet stemmer ikke overens med det, der stod på bankdokumentet.",
  errorMessage_1_7021: "Bankdokumentet viste ikke et officielt banklogo.",
  errorMessage_1_7022: "Bankdokumentet viste ikke et officielt bankstempel.",
  errorMessage_1_8009: "Organisationens juridiske navn mangler i bestyrelsesmedlemsbeviset",
  errorMessage_1_8010: "Organisationens juridiske navn er forskelligt fra det, der præsenteres i dokumentet",
  errorMessage_1_8011: "Direktørens navn mangler i bestyrelsesmedlemsbevis",
  errorMessage_1_8012: "Direktørens navn er forskelligt fra det, der præsenteres i dokumentet",
  errorMessage_1_8013: "Det leverede bestyrelsesmedlemsbevis understøttes ikke",
  errorMessage_1_8014: "Bestyrelsesmedlemsbevis var for gammelt",
  errorMessage_1_8015: "Bevis for direktør-billede var af for lav kvalitet",
  errorMessage_1_9009: "Dokumentation for finansiering stemte ikke overens med typen af finansieringskilde.",
  errorMessage_1_9010: "Det juridiske virksomhedsnavn stemte ikke overens med det, der var vist på dokumentationen for finansiering.",
  errorMessage_1_9011: "Dokumentationen for finansiering var for gammel.",
  errorMessage_1_9012: "Det juridiske firmanavn blev ikke fundet i dokumentationen for finansiering.",
  errorMessage_2_1101: "Yderligere oplysninger er nødvendige for at bekræfte din finansieringskilde.",
  errorMessage_2_1102: "Nogle oplysninger vedrørende finansieringskilden mangler stadig bevis for finansieringskilden.",
  errorMessage_2_1103: "Bevis for finansieringskilden, der viser forskellige typer af midler.",
  errorMessage_2_1110: "Nogle beviser for finansieringskilden opfyldte ikke kravene.",
  errorMessage_2_1111: "Nogle beviser for finansieringskilden syntes ikke at tilhøre din virksomhed.",
  errorMessage_2_1112: "Nogle beviser for finansieringskilden er for gamle.",
  errorMessage_2_1113: "Nogle beviser forfinansieringskilden viste ikke et juridisk firmanavn.",
  errorMessage_2_8064: "Den ultimative ejer (UBO) gennem ejerskab manglede.",
  errorMessage_2_8067: "Underskriveren manglede.",
  errorMessage_2_8141: "Registreringsdokumentet manglede.",
  errorMessage_2_8150: "'phone.number' manglede",
  errorMessage_2_8162: "proofOfOrganizationTaxInfo manglede.",
  errorMessage_2_8183: "'webAddress' manglede.",
  errorMessage_2_8189: "Den ultimative ejer (UBO) gennem kontrol manglede.",
  errorMessage_2_8193: "Direktøren manglede.",
  errorMessage_2_8196: "Dokument som bevis for ejerskab til at udføre bekræftelse manglede.",
  errorMessage_2_8203: "organization.economicSector manglede",
  errorMessage_2_8204: "organization.globalLegalEntityIdentifier manglede",
  errorMessage_2_8224: "Dokumentation for finansiering eller formuekilde manglede.",
  errorMessage_2_8225: "Den institutionelle sektor manglede.",
  errorMessage_2_8226: "Den juridiske formular manglede.",
  errorMessage_2_8227: "Status for retssager manglede.",
  errorMessage_2_8228: "Dato for indledning af retssager manglede.",
  errorMessage_2_8229: "Indikator for hovedkontor manglede.",
  errorMessage_2_8234: "'organization.countryOfGoverningLaw' manglede.",
  errorMessage_2_8236: "Bevis for direktøren manglede.",
  errorMessage_2_8247: "'organization.support.email' manglede",
  errorMessage_2_8248: "'individual.support.email' manglede",
  errorMessage_2_8249: "'organization.support.phone.number' manglede",
  errorMessage_2_8250: "'individual.support.phone.number' manglede",
  errorMessage_3_10: "Gennemgang af data er påkrævet",
  errorSubmittingData: "Fejl ved indsendelse af data",
  errorUpdatingSourceOfFunds: "Fejl ved opdatering af kilde til midler",
  estateAttorneysName: "Advokatens navn",
  euVatNumber: "EU-momsnummer",
  exemptedFromTax: "Fritaget fra skat",
  expiryDate: "Udløbsdato",
  extractFromMunicipalPersonalRecordsDatabase: "Uddrag fra registeret for personoplysninger",
  failedFetchingDecisionMaker: "Kunne ikke hente detaljer om beslutningstager",
  failedFetchingLegalRepresentative: "Kunne ikke få oplysninger om juridisk repræsentant",
  failedInitializeInstantVerification: "Det lykkedes ikke at initialisere processen for øjeblikkelig kontobekræftelse",
  failedToDeletePayoutAccount: "Kunne ikke slette udbetalingskonto",
  failedToDownloadAcceptedServiceAgreementDocument: "Det lykkedes ikke at ikke downloade dokument for accepteret serviceaftale",
  failedToDownloadPci: "Kunne ikke downloade PCI-dokument(er)",
  failedToDownloadServiceAgreementDocument: "Det lykkedes ikke at downloade serviceaftaledokumentet",
  failedToFetchAcceptedByName: "Det lykkedes ikke at hente den juridiske enhed, der accepterede serviceaftalen",
  failedToFetchPayoutAccount: "kunne ikke hente udbetalingskonto",
  failedToFetchRelevantDocuments: "Kunne ikke hente relevante dokumenter",
  failedToFetchSoleProp: "Kunne ikke hente enkeltmandsvirksomheden",
  failedToFetchTrustDetails: "Kunne ikke hente forvaltningsoplysninger",
  failedToFetchTrustMemberDetails: "Kunne ikke hente oplysninger om forvaltningsmedlem",
  failedToGetPciTemplate: "Det lykkedes ikke at hente PCI-skabelon",
  failedToGetPciTemplateInSelectedLanguageFallbackToEn: "Det lykkedes ikke at hente PCI-skabelonen på det valgte sprog. Går tilbage til engelsk.",
  failedToGetServiceAgreementInSelectedLanguageFallbackToEn: "Det lykkedes ikke at hente serviceaftalen på det valgte sprog. Går tilbage til engelsk.",
  failedToLoadBusinessLines: "Kunne ikke indlæse forretningslinjer",
  failedToRemoveDecisionMaker: "Kunne ikke fjerne beslutningstager",
  failedToRemoveTrustMember: "Kunne ikke fjerne forvaltningsmedlem",
  failedToUpdateDetails: "Kunne ikke opdatere detaljer",
  familyTrust: "Familiefond",
  fieldHasUnsupportedFormats: "%{fieldName} har et format, der ikke understøttes.",
  fieldIsRequired: "Feltet er påkrævet",
  fieldMustContainAtLeast: "%{fieldName} skal indeholde mindst %{minLength} tegn",
  fileName: "Filnavn",
  financialInformation: "Finansielle oplysninger",
  financialProductFundingSources: "Finansieringskilder til finansielle produkter",
  financialProductInformation: "Oplysninger om finansielle produkter",
  financialReportingDate: "Dato for finansiel rapportering",
  findYourIncorporatedAssociationNumberInThePublicRegistryForYourState: "Find dit foreningsnummer i det offentlige register for din stat.",
  finish: "Afslut",
  finishLater: "Afslut senere",
  firmenbuchnummer: "Firmenbuchnummer",
  firstHomeSaverAccountsTrust: "Forvaltning af opsparingskonto til første bolig",
  firstName: "Fornavn",
  firstNameOfSettlor: "Fornavn på stifter",
  fixedTrust: "Forvaltning af fast enhed",
  fixedUnitTrust: "Forvaltning af fast enhed",
  forExample_: "For eksempel: %{examples}",
  formatIsCorrect: "Formatet er korrekt",
  franchiseesTAndCs: "Vilkår og betingelser for franchisetagere",
  frontPage: "Forside",
  fullDocumentVisible: "Det fulde dokument skal være synligt, og al tekst skal kunne læses",
  fullDocumentVisibleWithReadableText: "Det fulde dokument skal være synligt, og al tekst skal kunne læses",
  fullLegalName: "Fuldt juridisk navn",
  fundDepositAmount: "Indbetalingsbeløb",
  fundDepositDate: "Indbetalingsdato",
  fundingSources: "Finansieringskilder",
  fundTransferDate: "Dato for pengeoverførsel",
  gamblingProceedDetails: "Oplysninger om gambling-fortjeneste",
  gamblingWebsite: "Gambling-hjemmeside",
  "GEMI-number": "GEMI-nummer eller ΑΡΙΘΜΟΣ Γ.Ε.ΜΗ (Γενικού Εμπορικού Μητρώου)",
  generalPartnership: "Generelt partnerskab",
  getSetUpInstantly: "Bliv konfigureret med det samme",
  gettingStarted: "Kom godt i gang",
  getYourBusinessVerifiedDetails: "Få din virksomheds bekræftede oplysninger med det samme, og spring upload af dokumenter over.",
  getYourVerifiedDetailsInstantly: "Få dine bekræftede oplysninger med det samme, og spring upload af dokumenter over.",
  giftOrDonationAgreement: "Aftale om gave eller donation",
  giftOrDonationDetails: "Oplysninger om gave eller donation",
  goBack: "Gå tilbage",
  goBackAndProvideDocumentScans: "Gå tilbage og indgiv dokumentscanninger",
  good: "God",
  goToIntroduction: "Hvordan fungerer det?",
  goToOverview: "Gå til oversigt",
  goToOverviewFromIntroduction: "Spring intro over",
  governmentalOrganizationDescription: "Din organisation er ejet af regeringen eller staten.",
  governmentalOrganizationTitle: "Statsorganisation",
  governmentIssuedCorrespondence: "Korrespondance udstedt af regeringen",
  grantOfProbate: "Grant of probate",
  grTaxId: "Αριθμός Φορολογικού Μητρώου Arithmós Forologikou Mētrṓou (ΑΦΜ)",
  gst: "Skat på varer og tjenesteydelser (Goods and Services Tax, GST)",
  guardian: "værge",
  guardianshipCertificate: "Værgemålsattest",
  handelsregisternummer: "Handelsregisternummer",
  hasBankStampOrBankSignature: "Inkluderer et bankstempel eller en signatur",
  hasDba: "Bruger din virksomhed et binavn (DBA name)?",
  hasDba__helperText: "Et binavn (Doing Business As name) er en version af din virksomheds navn, der kan være mere genkendelig for shoppere, men adskiller sig fra det juridiske navn.",
  hasToBeOfficialDocumentFromBank: "Inkluderer bankens logo, bankens navn eller bankspecifik skrifttype",
  helpUsVerifyCompany: "Hjælp os med at bekræfte denne virksomhed.",
  hideDetails: "Skjul detaljer",
  highResolutionCheck: "Billede i høj opløsning, der viser hele checken med tydeligt synlige sikkerhedsfunktioner",
  hkid: "HKID-nummer",
  howDoesVerificationWithOurPartnerWorks: "Hvordan fungerer bekræftelse med vores partner %{provider}?",
  howVerificationWithOnfidoWork: "Hvordan fungerer bekræftelse med vores partner Onfido?",
  howWouldYouLikeToSetUpYourAccount: "Hvordan vil du konfigurere din konto",
  howYourCustomersCanReachYou: "Hvordan dine kunder kan kontakte dig med spørgsmål eller bekymringer. Kontaktoplysninger kan blive vist på kundens kontoudtog.",
  huRegistrationNumber: "Cégjegyzékszám",
  huTaxId: "Közösségi adószám",
  hybridTrust: "Hybrid forvaltning",
  iban: "IBAN",
  ibanFormat: "Internationalt bankkontonummer (IBAN)",
  ICO: "IČO (Identifikační číslo)",
  id: "ID",
  idDocument: "ID-dokument",
  idDocumentAlreadyUploaded: "Identitetsdokumentet er allerede uploadet eller er for stort. Prøv et andet",
  identifikacionenNomerDDS: "Momsnummer (ДДС)",
  identityCard: "Identitetskort",
  identityCardBack: "Identitetskort (bagside)",
  identityCardFront: "Identitetskort (forside)",
  identityNumberExempt: "Jeg har ikke et identitetsnummer",
  identityNumberExempt__CA: "Jeg har ikke et SIN",
  identityNumberExempt__US: "Jeg har ikke et SSN",
  identityVerification: "Identitetsbekræftelse",
  idNumber: "Identitetsnummer",
  iDoNotHaveCompanyRegistrationNumber: "Jeg har ikke et CVR-nummer (CRN)",
  iDoNotHaveGst: "Jeg har ikke et GST-nummer (Goods and Services Tax)",
  iDontHaveARegistrationNumber: "Jeg har ikke et registreringsnummer",
  iDontHaveATaxId: "Jeg har ikke et skatte-id",
  iDontHaveAVatNumber: "Jeg har ikke noget momsnummer",
  iDontKnow: "Det ved jeg ikke",
  idUploadDocumentSubtitle: "For at vi kan bekræfte identiteten af <strong>%{name}</strong>, skal vi se hans/hendes myndighedsudstedte ID. Vælg den metode, der passer bedst.",
  ifNoOwnersSpecifyControllingPersons: "Hvis du ikke har nogen ejere med en ejerandel på 25 % eller mere, skal du angive <strong>alle kontrollerende personer</strong>.",
  ifYouChooseToUseOnfido: "Hvis du vælger at bruge Onfido, bekræfter du, at du har læst, forstået og accepteret",
  iHaveReadAndIAcceptTheseTerms: "Jeg har læst og accepterer disse vilkår og bekræfter, at jeg er en juridisk repræsentant, der er bemyndiget til at acceptere disse vilkår på virksomhedens vegne. Jeg har noteret mig erklæringen om beskyttelse af personlige oplysninger (www.adyen.com/policies-and-disclaimer/privacy-policy) og jeg giver mit samtykke til, at mine (personlige) oplysninger anvendes til de formål, der er beskrevet heri.",
  imagesInColor: "Billederne skal være i farver",
  includeFrontAndBack: "Medtag både forsiden og bagsiden, hver i en separat fil",
  includesEIN: "Inkluderet dit EIN (Employer Identification Number)",
  includesEvidenceOfTheIndividualsRole: "Inkluderer dokumentation for personens rolle som direktør",
  includesLegalCompanyName: "Inkluderer det juridiske navn på din virksomhed",
  includesTheDirectorsFullName: "Indeholder direktørens fulde navn",
  incorporatedAssociationRegistrationNumber: "Foreningens registreringsnummer",
  individual: "Individ",
  individualDetails: "Individuelle detaljer",
  individualTrustee: "Individuel tillidshaver",
  individualTrusteeDetails: "Individuelle tillidshaverdetaljer",
  industryAndNaceCode: "Branche- og NACE-kode",
  industryExemption: "De leverede varer eller tjenesteydelser er fritaget for moms",
  infoInUploadedDocumentIsTrue: "Alle oplysninger i det uploadede dokument skal være sande og opdaterede.",
  informationCouldNotBeSubmitted: "Oplysningerne kunne ikke indsendes",
  inheritanceAmount: "Arvebeløb",
  inheritanceDetails: "Oplysninger om arv",
  inheritanceReceivedOn: "Arv modtaget den",
  inReview: "Til gennemgang",
  instant: "Øjeblikkeligt",
  instantIDVerificationDescription: "Tag et billede af et pas, identitetskort eller kørekort.",
  instantlyAddAndVerifyABankAccount: "Tilføj og bekræft straks en bankkonto til udbetalinger",
  instantlyConnectAndVerifyYourBankAccount: "Tilknyt og bekræft din bankkonto med det samme",
  instantVerification: "Straksgodkendelse",
  instantVerificationDescription: "Log ind på din bankkonto og bliv bekræftet med det samme.",
  institutionNumber: "Institutionsnummer",
  internalCompanyDocument: "Internt virksomhedsdokument",
  inTheNextStepWellCollectInformation: "I næste trin beder vi om oplysninger om den oprindelige kilde til midler, der blev brugt med vores kommercielle kortprogrammer eller andre finansielle tjenester. Dette hjælper med at sikre, at disse produkter bruges på en sikker og beskyttet måde.",
  inThePreviousStepOwnedByAnUltimateParentCompany: "I et tidligere trin angav du, at din virksomheds moderselskab var ejet af et ultimativt moderselskab. Vi har brug for at få nogle oplysninger om dette firma, før du kan indsende ansøgningen.",
  inThePreviousStepOwnedByAParentCompany: "I sidste trin angav du, at din virksomhed er ejet af et moderselskab. Vi har brug for at få nogle oplysninger om dette firma, før du kan indsende ansøgningen.",
  introductionScreenAccountDescriptionP1: "Eksempelvis kontoindehaverens navn og kontonummer.",
  introductionScreenAccountDescriptionP2: "Det er bankkontoen, du bruger til at sende eller modtage midler.",
  introductionScreenAccountTitle: "Bankkontooplysninger",
  introductionScreenCompanyDescriptionLI1: "Dit virksomhedsregistreringsdokument",
  introductionScreenCompanyDescriptionP1: "Eksempelvis dit firmanavn og registreringsnummer.",
  introductionScreenCompanyDescriptionP2: "Hvor kan man finde disse oplysninger?",
  introductionScreenCompanyTitle: "Virksomhedsoplysninger",
  introductionScreenDecisionMakerDescriptionLI1: "Kørekort",
  introductionScreenDecisionMakerDescriptionLI2: "Pas",
  introductionScreenDecisionMakerDescriptionLI3: "ID-dokument",
  introductionScreenDecisionMakerDescriptionP1: "Eksempelvis navn og adresse på vigtige personer i din virksomhed.",
  introductionScreenDecisionMakerDescriptionP2: "Hvor kan man finde disse oplysninger?",
  introductionScreenDecisionMakerTitle: "Beslutningstagere",
  introductionScreenEpilogueDescriptionP1: "Vi kontrollerer alle disse oplysninger mod officielle registre for at bekræfte din identitet og overholde de finansielle bestemmelser.",
  introductionScreenEpilogueDescriptionP2: "Oplysningerne bruges kun til disse formål.",
  introductionScreenEpilogueTitle: "Hvorfor har vi brug for disse oplysninger?",
  introductionScreenIndividualDescriptionLI1: "Kørekort",
  introductionScreenIndividualDescriptionLI2: "Pas",
  introductionScreenIndividualDescriptionLI3: "ID-dokument",
  introductionScreenIndividualDescriptionP1: "Eksempelvis dit navn og din bopælsadresse.",
  introductionScreenIndividualDescriptionP2: "Hvor kan man finde disse oplysninger?",
  introductionScreenIndividualTitle: "Personlige oplysninger",
  introductionScreenPrologueDescriptionP1: "Vi beder om nogle oplysninger om din virksomhed som en del af de finansielle regler.",
  introductionScreenPrologueDescriptionP2: "Vores råd? Hav oplysningerne ved hånden, så du hurtigt kan blive verificeret.",
  introductionScreenPrologueTitle: "Før du går i gang...",
  introductionScreenSoleProprietorCompanyDescriptionLI1: "Dit registreringsdokument for enkeltmandsvirksomhed",
  introductionScreenSoleProprietorCompanyDescriptionP1: "Eksempelvis dit firmanavn og skatteidentifikationsnummer.",
  introductionScreenSoleProprietorCompanyDescriptionP2: "Hvor kan man finde disse oplysninger?",
  introductionScreenSoleProprietorCompanyTitle: "Oplysninger om enkeltmandsvirksomhed",
  introductionScreenTrustDescriptionLI1: "Din forvaltnings registreringsdokument.",
  introductionScreenTrustDescriptionP1: "Eksempelvis din forvaltnings navn og virksomhedsnummer. Du skal også uploade dit forvaltningsdokument.",
  introductionScreenTrustDescriptionP2: "Hvor kan man finde disse oplysninger?",
  introductionScreenTrustMemberDescriptionLI1: "Kørekort",
  introductionScreenTrustMemberDescriptionLI2: "Pas",
  introductionScreenTrustMemberDescriptionLI3: "ID-dokument",
  introductionScreenTrustMemberDescriptionP1: "Navn, fødselsdato og adresse på forvaltningsmedlemmer som f.eks. stiftere og modtagere.",
  introductionScreenTrustMemberDescriptionP2: "Hvor kan man finde disse oplysninger?",
  introductionScreenTrustMemberTitle: "Forvaltningsmedlemmer",
  introductionScreenTrustTitle: "Forvaltningsoplysninger",
  invalidCapabilities: "Nogle funktioner er ugyldige.",
  invalidDateOfBirth: "Indtast en gyldig fødselsdato",
  invalidDateOfIncorporation: "Indtast en gyldig dato for oprettelse",
  invalidEmail: "Indtast en gyldig e-mail",
  invalidFinancialReportingDate: "Indtast en gyldig rapporteringsdato",
  invalidFormat: "Ugyldigt format",
  invalidFormatBankStatementDescription: "Sørg for, at dit input kun indeholder bogstaver, cifre, valutakoder og de angivne specialtegn: -._,:;'*!@#%()+?¿/「」",
  invalidFormatExpects: "Ugyldigt format. Forventet format: %{format}",
  invalidFormatForAuDriversLicenseCardNumber: "Dette er ikke et gyldigt australsk kørekortnummer. Forventet format: 6-10 alfanumeriske tegn.",
  invalidFormatForAuDriversLicenseNumber: "Dette er ikke et gyldigt australsk kørekortnummer. Forventet format: 6-11 alfanumeriske tegn.",
  invalidFormatForAuPassportNumber: "Dette er ikke et gyldigt australsk pasnummer. Forventet format: 1-2 bogstaver efterfulgt af 7 tal.",
  invalidFormatForHKDriversLicenseNumber: "Ikke gyldig for HK. Format skal være: 8 alfanumeriske tegn. For eksempel: A1234567",
  invalidFormatForHKIdentityCardNumber: "Ikke gyldig for HK. Format skal være: 8 eller 9 alfanumeriske tegn. For eksempel: C668668A",
  invalidFormatForHKPassportNumber: "Ikke gyldig for HK. Format skal være: 9-tegn alfanumerisk. For eksempel: K12345599",
  invalidFormatForNZDriversLicenseCardNumber: "Forventet format skal være: 3 cifre",
  invalidFormatForNZDriversLicenseNumber: "Forventet format skal være: 2 tegn, efterfulgt af 6 cifre",
  invalidFormatForNZPassportNumber: "Forventet format skal være 8-9 alfanumeriske tegn. For eksempel: PA094043.",
  invalidFormatIdentityNumberBR: "Brug CFP-formatet: XXX.XXX.XXX-XX",
  invalidFormatIdentityNumberCA: "Brug SSN-formatet: XXXXXXXXX",
  invalidFormatIdentityNumberDK: "Brug CPR-formatet: XXXXXX-XXXX",
  invalidFormatIdentityNumberES: "Brug DNI-formatet: L0000000J",
  invalidFormatIdentityNumberHK: "Ikke gyldig for HK. Format skal være: 8 eller 9 alfanumeriske tegn. For eksempel: C668668E",
  invalidFormatIdentityNumberIT: "Brug Codice fiscale-formatet: ABCDEF11B12A123O",
  invalidFormatIdentityNumberPL: "Brug PESEL-formatet: XXXXXXXXXXX",
  invalidFormatIdentityNumberRO: "Brug CNP-formatet: XXXXXXXXXXXXX",
  invalidFormatIdentityNumberSE: "Brug Personnummer-formatet: ÅÅÅÅMMDD-XXXX eller ÅÅÅMMDD-XXXX",
  invalidFormatIdentityNumberSG: "Brug NRIC-formatet: S1234567A",
  invalidFormatIdentityNumberUS: "Angiv de 4 sidste cifre",
  invalidFormatIdentityNumberUS9: "Brug SSN-formatet: XXXXXXXXX",
  invalidInputError: "Der opstod en ugyldig indtastningsfejl:",
  invalidNumberOfEmployees: "Indtast et gyldigt nummer",
  invalidPhoneNumber: "Indtast et gyldigt telefonnummer",
  investmentAmount: "Investeringsbeløb",
  investmentCertificate: "Investeringsbevis",
  investor: "Investor",
  investorContract: "Investorkontrakt",
  investorDetails: "Oplysninger om investor",
  investorLocation: "Investors placering",
  investorMemo: "Investornotat",
  invoicesFromThe3MostRecentMonths: "Fakturaer fra de seneste 3 måneder, der viser omsætningsbeløbet",
  irdDocument: "IRD-dokument",
  irdNumber: "IRD-nummer",
  irsCP575: "IRS CP 575-brev",
  irsScheduleK1: "IRS-skema K-1 (formular 1065)",
  isCompanyOwnedByAnotherCompany: "Er %{company} ejet af en anden virksomhed?",
  isOurTrustedPartnerHelpingSpeedUpSetup: "%{provider} er vores betroede partner, der er med til at gøre din kontoopsætning hurtigere ved at bekræfte din bankkonto med det samme.",
  isParentOwnedByAnotherCompany: "Er dit moderselskab ejet af en anden virksomhed?",
  issueDate: "Udstedelsesdato",
  issueDateWithinTheLast3Months: "Udstedelsesdato inden for de seneste 3 måneder",
  issueDateWithinTheLast12Months: "Udstedelsesdato inden for de seneste 12 måneder",
  issuedByTheTaxAuthority: "Udstedt af skattemyndigheden eller regeringen i det land, hvor virksomheden er registreret",
  issuedOrSignedByALegalRepresentative: "Udstedt eller underskrevet af en juridisk repræsentant inden for de sidste 12 måneder",
  issuedWithinTheLast12Months: "Udstedt inden for de seneste 12 måneder",
  issuerState: "Udstedelsesstat",
  issuingService: "Betalingskort (fysiske eller virtuelle)",
  isThisAddressTheMainHeadquarters: "Er hovedkvarteret på denne adresse?",
  isThisPersonANomineeDirector: "Er denne person en nominel direktør?",
  isThisPersonANomineeShareholder: "Er denne person en proformaaktionær?",
  iStillCantFindIt: "Jeg kan stadig ikke finde dem.",
  isTrustOperationAddressSame: "Er der en anden adresse for din forvaltnings aktiviteter?",
  isYourNameMissingFromSigners: "Mangler dit navn på listen over underskrivere?",
  itCanTakeUpTo: "Det kan tage op til 3 ekstra arbejdsdage at verificere personlige oplysninger, der er tilføjet manuelt.",
  jobTitle: "Stillingsbetegnelse",
  kaibemaksukohustuslaseNumber: "Käibemaksukohustuslase-nummer",
  krsNumber: "KRS-nummer",
  last4DigitsOfSocialSecurityNumber: "Sidste 4 cifre i socialsikringsnummer (SSN)",
  lastName: "Efternavn",
  lastNameOfSettlor: "Efternavn på stifter",
  latestTaxFiling: "Seneste skatteindberetning",
  latestTaxReturn: "Seneste skatteopgørelse",
  leave: "Forlad",
  leaveInstantVerification: "Vil du forlade straksgodkendelse?",
  leaveVerification: "Forlad godkendelse",
  legalCompanyName: "Juridisk firmanavn",
  legalCompanyName__helperText: "Det juridiske navn bruges til at identificere en virksomhed over for myndighederne; indtast det nøjagtigt, som det står på dine offentlige eller juridiske dokumenter.",
  legalCompanyName__helperText__AU: "Indtast navnet nøjagtigt som det står på din Australian Securities and Investment Commission's (ASIC).",
  legalCompanyName__helperText__HK: "Indtast navnet nøjagtigt, som det står på dit Hong Kong Companies Registry's Certificate of Incorporation.",
  legalCompanyName__helperText__NL: "Indtast navnet nøjagtigt som skrevet på registreringen i handelskammeret.",
  legalCompanyName__helperText__PR: "Indtast navnet nøjagtigt, som det står på din registrering hos Department of State.",
  legalCompanyName__helperText__SG: "Indtast navnet nøjagtigt, som det står på din Accounting and Corporate Regulatory Authority (ACRA) BizFile.",
  legalCompanyName__helperText__US: "Indtast navnet nøjagtigt, som det står på din registrering hos Secretary of State.",
  legalCompanyName__helperText__US__business: "Det juridiske navn bruges til at identificere en virksomhed over for myndighederne; indtast det nøjagtigt, som det står på dine offentlige eller juridiske dokumenter.",
  legalCompanyName__US: "Juridisk firmanavn",
  legalEntityIdentifier: "Legal Entity Identifier (LEI-kode)",
  legalForm: "Juridisk formular",
  legalInformation: "Juridisk information",
  legalInformationInsolvency: "Er denne virksomhed involveret i en retssag i forbindelse med insolvens?",
  legalName: "Juridisk navn",
  legalNameIsUsedToIdentifyABusinessWithTheGovernment: "Det juridiske navn bruges til at identificere en virksomhed over for myndighederne; indtast det nøjagtigt, som det står på offentlige, juridiske eller skattemæssige dokumenter.",
  legalNameOfSoleProprietor: "Enkeltmandsvirksomhedens juridiske navn",
  legalNameOfSoleProprietorship: "Enkeltmandsvirksomhedens juridiske navn",
  legalOwnerOfProperty: "Den juridiske ejer af ejendommen i forvaltning.",
  legalProceedingsDate: "Startdato for retssag",
  legalRepresentative: "Juridisk repræsentant",
  legalRepresentativeDetails: "Oplysninger om juridisk repræsentant",
  legalRepresentativeFor: "juridisk repræsentant for: %{firstName} %{lastName}",
  legalRepresentativeNeeded: "Brugeren er mindreårig, derfor kræves der en juridisk repræsentant.",
  lendersNameAndAddress: "Långivers navn og adresse",
  letterFromAccountant: "Et brev fra revisor",
  letterFromAttorney: "Et brev fra advokaten",
  letterFromAttorneyInsurance: "Et brev fra advokaten",
  letterFromAttorneyOrNotary: "Et brev fra advokat eller notar",
  letterFromInsurer: "Et brev fra forsikringsselskabet",
  letterFromPreviousEmployer: "Et brev fra tidligere arbejdsgiver",
  letUsKnowTheBankAccountToSendReceiveFunds: "Lad os vide, hvilken bankkonto du bruger til at sende eller modtage midler.",
  licenceVersionNumber: "Licensens versionsnummer",
  licenseCardNumber: "Kortnummer",
  licenseNumber: "Kørekortnummer",
  liRegistrationNumber: "Unternehmensnummer",
  listedPublicUnitTrust: "Forvaltning af anført offentlig enhed",
  listitemVoidedChequeBankLetterBankStatementOnline: "Ugyldig check/bankbrev/kontoudtog/netbankmiljø",
  loading: "Indlæser",
  loanAgreement: "Låneaftale",
  loanApplication: "Låneansøgning",
  loanDate: "Lånedato",
  loans: "Lån",
  loanStatement: "Låneopgørelse",
  localFormat: "Lokalt format",
  loginIntoYourBankingEnvironment: "Log ind på dit bankmiljø via en mobilapp eller internetbrowser.",
  lookUpYourLEI: "Slå din LEI op.",
  ltRegistrationNumber: "Įmonės kodas",
  luRegistrationNumber: "Numéro registre de commerce et des sociétés (RCS) eller Registernummer",
  lvRegistrationNumber: "Komersanta reģistrācijas numurs (NBR)",
  lvTaxId: "Pievienotās vērtības nodokļa reģistrācijas numurs (PVN)",
  madeAMistake: "Har du lavet en fejl?",
  maintenanceModeMessage: "Vi er i øjeblikket i gang med vedligeholdelse – hold denne side åben, indtil vedligeholdelsen er færdig, så du undgår at miste ændringer, der ikke er gemt.",
  makeSureToHaveYourTrustDeed: "Sørg for at have dit forvaltningsdokument parat, så du kan udfylde disse oplysninger korrekt.",
  manualIDVerificationDescription: "Det kan tage et par dage. Upload en kopi af et pas, identitetskort eller kørekort.",
  manuallyAddAccount: "Tilføj konto manuelt",
  manuallyAddAccountQuestion: "Tilføj konto manuelt?",
  manuallyAddAccountSlower: "Tilføj konto manuelt (langsommere)",
  manualUpload: "Manuel upload",
  manualVerificationDescription: "Du skal også angive dine bankkontooplysninger.",
  maxFileSize: "Maks. filstørrelse: %{maxSize}. Højst 1 side.",
  maxFileSizeOnly: "Maks. filstørrelse: %{maxSize}.",
  maximumFileSizeExceeded: "Maksimal filstørrelse er overskredet",
  mayTakeAFewDays: "Det kan tage et par dage",
  MBO: "MBO",
  MBS: "Matični broj subjekta trgovačkog suda (MBS)",
  mcRegistrationNumber: "Numéro de RCI",
  mcRegistrationNumberSoleProp: "Numéro d'Identification Statistique (NIS)",
  meetingRecords: "Beslutningsreferater fra bestyrelsesmøder",
  Mehrwertsteuernummer: "Mehrwertsteuernummer (MwST), Numéro de TVA, Numero dell'imposta sul valore aggiunto (IVA), VAT number, momsnummer",
  memberDetails: "Medlemsdetaljer",
  missingCompanyDetails: "Manglende virksomhedsoplysninger eller rodenhed",
  missingMultipleDecisionMakers: "Du har ikke tilføjet alle nødvendige beslutningstagere",
  missingPhoneCountryCode: "Vælg en landekode",
  missingRequiredDecisionMakers: "Vi har endnu ikke et tilstrækkeligt antal beslutningstagere.",
  missingRequiredTrustMembers: "Vi har endnu ikke tilstrækkeligt med forvaltningsmedlemmer.",
  momsregistreringsnummer: "Momsregistreringsnummer",
  momsregistreringsnummerCVR: "Momsregistreringsnummer (CVR)",
  mortgageStatement: "Erklæring om realkreditlån",
  mvanummer: "MVA-nummer",
  myinfoBusinessDetailsRetrieved: "Virksomhedsoplysninger fra Myinfo hentet",
  myInfoBusinessYouCanGetVerifiedDetails: "Med Myinfo-virksomhed kan du få din virksomheds bekræftede oplysninger med det samme og springe upload af dokumenter over.",
  myinfoDetailsRetrieved: "Myinfo-oplysninger hentet",
  myInfoYouCanGetVerifiedDetails: "Med Myinfo kan du få dine bekræftede oplysninger med det samme og springe upload af dokumenter over.",
  myName: "Mit navn",
  mySoleProprietorName: "Min enkeltmandsvirksomheds navn",
  nameAddressSignatureOfAllInvestors: "Navn, adresse og underskrift af alle investorer",
  nameMustContainLetters: "Navnet skal indeholde bogstaver. Kontroller for skrivefejl, og prøv igen.",
  nameOfCasinoLottery: "Navn på kasino, lotteri eller anden spillevirksomhed",
  nameOfCasinoLotteryGambling: "Navn på kasino, lotteri eller anden spillevirksomhed.",
  nameOfTheCoins: "Navn på mønt(er)",
  nameOfTheCryptocurrencyExchange: "Navnet på kryptovalutaudvekslingen",
  nameOfTheExchangeWhereTheCryptocurrencyWasHeldPriorToSale: "Navn på kryptovalutaudvekslingen, hvor den blev opbevaret før salget",
  nameOfTrust: "Forvaltningens navn",
  nameOfTrustAgreement: "Navn på forvaltningsaftale",
  namesOfInvolvedParties: "Navne på involverede parter (hvis relevant)",
  namesOfLandlordAndTenant: "Navne på udlejer og lejer",
  national_identity_card: "Nationalt ID-kort",
  nationalIdNumber: "Nationalt ID-nummer",
  nationalInsuranceNumber: "National Insurance Number (NINO)",
  nationality: "Nationalitet",
  naturalPersonDescription: "Han/hun har ingen virksomhed.",
  naturalPersonTitle: "Fysisk person",
  needHelpYouCanAlwaysReachOutToCustomerSupport: "Brug for hjælp? Du kan altid kontakte kundesupport.",
  netProceedAmount: "Nettooverskudsbeløb",
  newEntityAlwaysEmpty: "Vi skal stadig oprette denne enhed.",
  next: "Næste",
  nie: "NIE",
  NIF: "NIF (Número de Identificación Fiscal)",
  NIFdeIVA: "Número de Identificación a efectos de IVA (Impuesto sobre el Valor Añadido)",
  NIP: "Numer identyfikacji podatkowej (NIP)",
  NIPC: "NIPC (Número de Identificação de Pessoa Colectiva)",
  no: "Nej",
  noCategoriesAvailable: "Ingen tilgængelige kategorier.",
  noGlare: "Ingen genskin",
  noGoBack: "Nej, gå tilbage",
  noIdontKnow: "Nej, eller det ved jeg ikke",
  noIssuesFound: "Ingen problemer blev fundet.",
  nominee: "Repræsentant",
  noneOfTheAbove: "Ingen af de ovenstående",
  nonProfitOrCharitableOrgDescription: "Din organisation har officiel nonprofit- eller skattefritaget status.",
  nonProfitOrCharitableOrgTitle: "Almennyttig/velgørende organisation",
  noOptionsFound: "Ingen muligheder fundet",
  notarizedStatement: "Notariseret erklæring",
  notBlurry: "Ikke sløret",
  notCutOff: "Ikke afbrudt",
  notExpired: "Ikke udløbet",
  nothingNeedsToBeSigned: "Intet skal underskrives lige nu.",
  nric: "National Registration Identity Card (NRIC)",
  numarOrdineRegistrulComertului: "Numar de ordine in registrul comertului",
  number: "-nummer",
  numberOfEmployees: "Antal medarbejdere",
  numerodeIVA: "Numéro de TVA",
  NumeroDeTVA: "Numéro de TVA intracommunautaire",
  numeroDIdentificationALATaxe: "Numéro d'identification à la taxe sur la valeur ajoutée",
  NZBN: "New Zealand Business Number (NZBN)",
  "NZBN/NCN": "New Zealand Business Number (NZBN) / Firmanummer (NCN)",
  objectOfCharitableTrust: "Formål for velgørenhedsforvaltning",
  objectOfTrust: "Formål for forvaltning",
  oib: "OIB",
  onboardingRedirectAwaitingCtaButton: "Fortsæt",
  onboardingRedirectAwaitingDescriptionP1: "Bekræft dine virksomhedsoplysninger for at begynde at modtage betalinger.",
  onboardingRedirectInReviewCtaButton: "Gå til oplysninger",
  onboardingRedirectInReviewDescriptionP1: "Vi gennemgår dine oplysninger. Det kan tage op til 2 arbejdsdage.",
  onboardingRedirectLinkError: "Onboarding-linket er ikke tilgængeligt i øjeblikket, prøv igen senere.",
  onboardingRedirectOpenError: "Pop op-blokering forhindrede omdirigering. Tillad pop op-vinduer til dette websted.",
  onboardingRedirectRejectedDescriptionP1: "Din konto kan ikke konfigureres.",
  onboardingRedirectUnsuccessfulCtaButton: "Opdater oplysninger",
  onboardingRedirectUnsuccessfulDescriptionP1: "Der var nogle oplysninger, vi ikke kunne bekræfte. Tjek, om de er korrekte, og foretag nødvendige ændringer.",
  onboardingRedirectVerifiedDescriptionP1: "Dine oplysninger er bekræftet.",
  onfido: "Onfido.",
  onfidoIsOurTrustedPartner: "Onfido er vores betroede partner, der er med til at gøre din kontoopsætning hurtigere ved at bekræfte din identitet i realtid.  ",
  onfidoPrivacyPolicy: "Onfido Privatlivspolitik",
  onfidoTermsOfService: "Onfidos servicevilkår",
  onfidoWillGiveFeedbackInRealTime: "Onfido giver dig feedback i realtid",
  operationalAddress: "Driftsadresse",
  operationalAddressHeader: "Yderligere adresse",
  operationalAddressIsNotSameItemName: "Ja, vores hovedkontor ligger et andet sted",
  operationalAddressIsSame: "Er der en anden adresse for din virksomheds hovedkvarter?",
  operationalAddressIsSameItemName: "Nej, den registrerede adresse er den, hvorfra vi driver virksomheden",
  optional: "(valgfrit)",
  organisasjonsnummer: "Organisasjonsnummer",
  organisationsnummer: "Organisationsnummer",
  organization: "Organisation",
  organizationsCountryOfOperation: "Organisationens driftsland/-område",
  organizationsLegalName: "Organisationens juridiske navn",
  original: "Original",
  originatorType: "Oprindelsestype",
  orSoleProprietorshipName: "eller enkeltmandsvirksomhedens navn",
  otherAddressInformation: "Andre adresseoplysninger",
  otherBusinessInformation: "Andre virksomhedsoplysninger",
  otherInformation: "Andre oplysninger",
  otherLegalMeasures: "Ja, virksomheden står over for andre juridiske foranstaltninger",
  otherTrust: "Anden forvaltning",
  ourFinancialServicesAreNotAvailableYetForPartnershipsAndAssociations: "Vores finansielle tjenester er endnu ikke tilgængelige for partnerskaber og foreninger.",
  owner: "Ejer",
  ownerDescription: "En person, der ejer 25% eller mere af virksomheden (direkte eller indirekte)",
  ownerGuideDescription: "En <strong>ejer</strong> er en person, der ejer 25 % eller mere af virksomheden gennem stemmerettigheder, aktier eller lignende.",
  ownershipStructure: "Ejerskabsstruktur",
  parent: "forælder",
  parentCompany: "Moderselskab",
  parentCompanyInformation: "Oplysninger om moderselskabet",
  partitaIVA: "Partita IVA",
  partnership: "Partnerskab",
  partnershipAgreement: "Partnerskabsaftale",
  partnerShipAgreement: "Partnerskabsaftale",
  partnershipIncorporated: "Kommanditselskab",
  partnershipIncorporatedDescription: "Du og dine partnere har begrænset ansvar for virksomhedens gæld.",
  partnershipOrAssociation: "Partnerskab eller forening",
  partnershipsUnincorporated: "Partnerskaber uden juridisk person",
  partnershipUnincorporated: "Partnerskab uden juridisk person",
  partnershipUnincorporatedDescription: "Du eller dine partnere hæfter personligt for virksomhedens gæld.",
  passport: "Pas",
  passportExpiryDate: "Udløbsdato for pas",
  passportNumber: "Pasnummer",
  passportPhotoPage: "Side med pasfoto",
  payinAccount: "Indbetalingskonto",
  payinAccountsDescription: "For at fuldføre din konto skal du fortælle os, hvor dine indbetalinger skal sendes hen.",
  payinDetails: "Indbetalingsoplysninger",
  paymentProcessingTerms: "Vilkår for behandling af betalinger",
  paymentService: "Accepter betalinger",
  payoutAccount: "Udbetalingskonto",
  payoutAccountsDescription: "For at opsætte din konto skal du fortælle os, hvor dine udbetalinger skal sendes hen.",
  payoutAccountsDescriptionReview: "For at sikre, at dine udbetalingsdata er korrekte, skal du kontrollere følgende oplysninger.",
  payoutDetails: "Oplysninger om udbetaling",
  payoutIn_Or_: "Udbetalinger til denne konto kan ske i %{currencyOne} eller %{currencyTwo}.",
  payoutInOnly_: "Udbetalinger til denne konto kan foretages i %{currency}.",
  payslips: "Lønsedler",
  pccr: "PCCR",
  pciDoesNotNeedSigningOrHasBeenSigned: "PCI DSS-spørgeskemaet behøver ikke at blive underskrevet eller er allerede underskrevet",
  pciDssQuestionnaire: "PCI DSS-spørgeskema",
  pciSignedSuccessfully: "PCI er underskrevet",
  pciSignFailed: "PCI-undskrift mislykkedes",
  PDVIdBrojOIB: "PDV Id. Broj OIB",
  pendingCapabilities: "Nogle funktioner er stadig under behandling.",
  pendingStatusError: "Der er en fejl med en afventende status.",
  pensionPaymentAmount: "Pensionsbetalingsbeløb",
  pensionPaymentAmountOrTotalValue: "Pensionsbetalingsbeløb eller samlet værdi",
  pensionSlip: "Pensionsopgørelse",
  pensionStatement: "Pensionsopgørelse",
  personalDetails: "Personlige oplysninger",
  personalIdentityDetails: "Personlige identitetsoplysninger",
  personalIdentityDetailsDescription: "Vi anvender kun disse oplysninger til identitetsbekræftelse. Læs mere om, hvordan dine data administreres i vores erklæring om beskyttelse af personlige oplysninger.",
  personAppointmentUnderTrustInstrument: "Den person, der er udnævnt under stiftelsesdokumentet til at lede eller begrænse administratorer i forhold til deres administration af forvaltningen.",
  personnummer: "Personnummer",
  peselNumber: "PESEL-nummer",
  phoneNumber: "Telefonnummer",
  phoneNumber__placeholder__AL: "00 000 0000",
  phoneNumber__placeholder__AS: "000-0000",
  phoneNumber__placeholder__NL: "0 00000000",
  phoneNumber__placeholder__SG: "0000 0000",
  phoneNumber__placeholder__US: "(000) 000-0000",
  pleaseEnsureTheFollowing: "Sørg for, at følgende afsnit er udfyldt for at fuldføre gennemgangen af dine data.",
  pleaseEnterAPhoneNumberPrefixedWithCountryCode: "Indtast et telefonnummer med en landekode foran, f.eks. %{defaultPrefix}.",
  pleaseEnterAValidAmount: "Indtast et gyldigt beløb.",
  pleaseEnterAValidNumber: "Indtast et gyldigt nummer",
  pleaseEnterAValidWholeNumber: "Indtast et gyldigt heltal",
  pleaseFillInAllFields: "Udfyld alle felter.",
  pleaseNote: "Bemærk:",
  pleaseProvideThePurposeOfCharitableTrust: "Angiv formålet med din velgørenhedsforvaltning",
  poBox: "Postboks",
  pooledSuperannuationTrust: "Forvaltning af samlet pensionsordning",
  postalCode: "Postnummer",
  poweredBy: "Drevet af",
  previous: "Forrige",
  previousEmployersName: "Tidligere arbejdsgivers navn",
  principalAmount: "Hovedbeløb",
  principalPlaceOfBusiness: "Hovedsæde for virksomhed",
  principalPlaceOfBusinessDescription: "Den fysiske placering, hvor en virksomheds nøglepersoner fører tilsyn med og administrerer dens drift: Dette er normalt hovedkontoret eller hovedkvarteret.",
  privateCompanyDescription: "Din virksomhed er privatejet og ikke børsnoteret. ",
  privateCompanyTitle: "Privat virksomhed",
  processing: "Under behandling",
  professionalServiceProvider: "Min stifter er en professionel tjenesteudbyder",
  progress: "Status",
  proofOfAddress: "Bevis for adresse",
  proofOfAnnualTurnoverAmount: "Bevis for årlig omsætningsbeløb",
  proofOfDirector: "Bevis for direktør",
  proofOfFundingOrWealthSource: "Bevis for finansiering eller formuekilde",
  proofOfIdentityCard: "Identitetskort",
  proofOfNationalId: "Bevis for nationalt id",
  proofOfNationalIdNumber: "Bevis for nationalt ID-nummer",
  proofOfOrganizationTaxInfo: "Bevis for organisationens skatteoplysninger",
  proofOfOwnership: "Bevis for ejerskab",
  proofOfOwnershipRent: "Bevis for ejerskab",
  proofOfRelationship: "Bevis for relation",
  proofOfResidenceDocumentTypeLabel: "Upload et dokument som bevis for adresse for %{name}. Vi har brug for at se dette dokument, så vi kan kontrollere deres identitet mere nøjagtigt.",
  proofOfResidency: "Bevis for bopæl",
  proofOfWalletOwnership: "Bevis for ejerskab af tegnebog",
  proofOfWinnings: "Bevis for gevinster",
  propertyAddress: "Ejendommens adresse (hvis relevant)",
  propertyDescription: "Beskrivelse af ejendommen",
  propertySaleDetails: "Oplysninger om salg af ejendommen",
  protector: "Protektor",
  protectorGuideDescription: "<strong>Protektor</strong> er den fysiske person, der er udpeget til at lede tillidshavere i forhold til deres administration af forvaltningen.",
  provideAllBeneficiaries: "Tilføj <strong>alle modtagere</strong>.",
  provideAllDirectors: "Tilføj <strong>alle direktører</strong>. Du bør have mindst 1 direktør.",
  provideAllOwners: "Tilføj <strong>alle ejere</strong>, der ejer 25 % eller mere af din virksomhed.",
  provideAllTrustees: "Tilføj <strong>alle tillidshavere</strong>.",
  provideAtLeastOneProtector: "Tilføj <strong>alle protektorer,</strong> hvis der er nogen.",
  provideAtLeastOneSettlor: "Tilføj mindst <strong>1 stifter</strong>.",
  provideAtLeastOneSignatory: "Tilføj mindst <strong>1 underskriver</strong>.",
  provideFewDetailsAboutYourself: "Angiv nogle oplysninger om dig selv.",
  provideMostRecentYearAvailable: "Angiv det seneste år, der er tilgængeligt",
  provideOneControllingPerson: "Angiv <strong>1 kontrollerende person</strong>.",
  providePageWithPhotoAndCode: "Angiv siden med billedet, herunder koden nederst på siden",
  providePersonalAddress: "Angiv personlig adresse",
  providePersonalDetailsOfOwner: "Angiv ejerens personlige oplysninger.",
  provinceOrTerritory: "Provins eller område",
  publicCompanyDescription: "Din virksomhed er børsnoteret og skal regelmæssigt offentliggøre finansielle oplysninger.",
  publicCompanyTitle: "Offentligt selskab",
  publicTradingTrust: "Forvaltning af offentlig enhed",
  purposeOfLoan: "Formål med lån",
  PVMmoketojoKodas: "PVM mokėtojo kodas",
  quickAndSecureIdentityVerification: "Hurtig og sikker identitetsbekræftelse med kørekort, pas eller andet ID-dokument – drevet af vores betroede partner, Onfido.",
  ranIntoTechnicalError: "Vi stødte på en teknisk fejl",
  reason: "Begrundelse",
  reasonForFillingCompanyAddressDetails: "Vi skal sikre os, at de virksomheder, der benytter vores tjenester, ikke misbruger midlerne eller gør skade. For at gøre det, tjekker vi alle disse oplysninger mod officielle registre. Dette er en del af de finansielle bestemmelser, som vi skal følge som betalingsudbyder.",
  reasonForFillingCompanyRegistrationDetails: "Vi skal sikre os, at de virksomheder, der benytter vores tjenester, ikke misbruger midlerne eller gør skade. For at gøre det, tjekker vi alle disse oplysninger mod officielle registre. Dette er en del af de finansielle bestemmelser, som vi skal følge som betalingsudbyder.",
  reasonForFillingIndividualAddressDetails: "Vi skal sikre os, at alle, der benytter vores tjenester, er dem, de siger, de er. For at gøre det, tjekker vi alle disse oplysninger mod officielle registre. Dette er en del af de finansielle bestemmelser, som vi skal følge som betalingsudbyder.",
  reasonForFillingIndividualPersonalDetails: "Vi skal sikre os, at alle, der benytter vores tjenester, er dem, de siger, de er. For at gøre det, tjekker vi alle disse oplysninger mod officielle registre. Dette er en del af de finansielle bestemmelser, som vi skal følge som betalingsudbyder.",
  reasonForFillingPayoutDetails: "Denne bankkonto vil blive verificeret for at forhindre svindel eller andet misbrug af midler i overensstemmelse med globale regler.",
  recentInvoices: "Seneste fakturaer",
  region: "Område",
  registeredAddress: "Registreret adresse",
  registeredAddressHeaderDescription: "Adressen, som den fremgår af din virksomheds officielle registreringsdokumenter.",
  registeredAddressHeaderDescription__NL: "Den adresse, som din virksomhed er registreret på hos handelskammeret.",
  registeredAddressHeaderDescription__PR: "Din adresse, som den vises på din registrering hos Department of State.",
  registeredAddressHeaderDescription__US: "Din adresse, som den fremgår af din registrering hos Secretary of State.",
  registeredAddressTrustHeaderDescription: "Den adresse, der er registreret til din forvaltning",
  registeredAddressUnincorporatedPartnershipHeaderDescription: "Adressen, der er registreret til dit partnerskaber uden juridisk person",
  registeredBusinessAddress: "Registreret virksomhedsadresse",
  registeredBusinessAddressDescription: "Din virksomheds officielle adresse, der bruges til offentlige og andre juridiske formål.",
  registeredBusinessAddressDescription__withCountry: "Din virksomheds officielle adresse, der bruges til offentlige og andre juridiske formål i %{country}.",
  registeredBusinessAddressDescription__withCountry__commonNoun: "Din virksomheds officielle adresse, der bruges til offentlige og andre juridiske formål i %{country}.",
  registrationAddress: "Registreringsadresse",
  registrationDetails: "Registreringsoplysninger",
  registrationDocument: "Registreringsdokument",
  registrationNumber: "Registreringsnummer",
  registrationNumber__helperText__US: "Dette hjælper os med at identificere og bekræfte din virksomhed.",
  registrationNumber__nonProfit__FR: "SIRET eller RNA",
  registrationNumber__US: "Statsregistreringsnummer",
  registrikood: "Registrikood",
  regon: "REGON",
  regonKrsNumber: "REGON-/KRS-nummer",
  rejected: "Afvist",
  relationship: "Relation",
  relationshipTo: "Relationd til %{firstName} %{lastName}",
  remediationFormErrorMessage: "Nogle oplysninger kunne ikke bekræftes. Oplysningerne i denne formular skal muligvis justeres.",
  remediationMessage_1_100: "Ingen afhjælpning mulig",
  remediationMessage_1_101: "Kontakt support",
  remediationMessage_1_102: "Upload et andet dokument",
  remediationMessage_1_300: "Opdater individuelle oplysninger",
  remediationMessage_1_301: "Upload et id-dokument",
  remediationMessage_1_302: "Upload et andet id-dokument",
  remediationMessage_1_303: "Upload et andet billede af id-dokumentet",
  remediationMessage_1_304: "Upload bevis for bopæl",
  remediationMessage_1_305: "Upload et andet bevis for bopæl",
  remediationMessage_1_306: "Upload et andet billede af beviset for bopæl",
  remediationMessage_1_307: "Upload et bevis på nationalt id-nummer",
  remediationMessage_1_308: "Upload et andet bevis på nationalt id-nummer",
  remediationMessage_1_309: "Upload et andet billede af beviset for det nationale id-nummer",
  remediationMessage_1_316: "Angiv et komplet 9-cifret socialsikringsnummer, eller upload et ID-dokument, hvis du ikke har et SSN.",
  remediationMessage_1_319: "Opdater individuelle oplysninger",
  remediationMessage_1_320: "Upload bevis for bopæl",
  remediationMessage_1_500: "Opdater organisationsoplysninger",
  remediationMessage_1_501: "Upload et registreringsdokument",
  remediationMessage_1_502: "Upload et andet registreringsdokument",
  remediationMessage_1_503: "Upload et skattedokument",
  remediationMessage_1_504: "Upload et andet skattedokument",
  remediationMessage_1_505: "Upload et bevis for adresse",
  remediationMessage_1_506: "Upload et andet bevis for adresse",
  remediationMessage_1_507: "Opdater oplysninger om organisationens ejerskab",
  remediationMessage_1_508: "Upload et bevis for ejerskab",
  remediationMessage_1_509: "Upload et andet tilknytningsdokument",
  remediationMessage_1_510: "Sørg for, at underskriveren har ret til at repræsentere organisationen eller er et opført professionelt medlem (advokat, revisor) i landet, hvor du driver forretning, og upload det korrekte dokument",
  remediationMessage_1_511: "Upload et dokument, der beviser, at udbetalingsenheden er 100 % tilknyttet den juridiske enhed",
  remediationMessage_1_512: "Upload et momsdokument",
  remediationMessage_1_513: "Upload et andet momsdokument",
  remediationMessage_1_519: "Opdater kilde til midler",
  remediationMessage_1_521: "Upload et andet bevis for finansieringskilden",
  remediationMessage_1_600: "Opdater oplysninger om juridisk enhed",
  remediationMessage_1_601: "Upload et stiftelsesdokument",
  remediationMessage_1_602: "Upload et andet stiftelsesdokument",
  remediationMessage_1_603: "Opdater medlemsoplysninger",
  remediationMessage_1_700: "Opdater bankkontooplysninger",
  remediationMessage_1_701: "Brug en anden bankkonto",
  remediationMessage_1_702: "Brug andre metoder til bekræftelse af bankkonto",
  remediationMessage_1_703: "Upload et kontoudtog",
  remediationMessage_1_704: "Upload et andet kontoudtog",
  remediationMessage_1_705: "Upload et officielt kontoudtog",
  remediationMessage_1_803: "Upload et bevis på direktør-dokument til juridisk enhed",
  remediationMessage_1_804: "Upload et andet bestyrelsesmedlemsbevis",
  remediationMessage_1_805: "Opdater oplysninger om direktøren",
  remediationMessage_2_123: "Du har ikke tilføjet en ejer",
  remediationMessage_2_124: "Du har ikke tilføjet en underskriver",
  remediationMessage_2_151: "Du har ikke tilføjet en kontrollerende person",
  remediationMessage_2_153: "Tilføj 'phone.number' til juridisk enhed",
  remediationMessage_2_158: "Angiv momsnummer eller årsag til fritagelse.",
  remediationMessage_2_178: "Føj 'webAddress' til virksomhedslinjen.",
  remediationMessage_2_184: "Tilføj forfatningsdokument til bekræftelse til juridisk enhed.",
  remediationMessage_2_185: "Du har ikke tilføjet dine direktører",
  remediationMessage_2_188: "Tilføj dokument som bevis for ejerskab til bekræftelse til juridisk enhed",
  remediationMessage_2_214: "Upload et bevis på finansiering eller formuekilde ....",
  remediationMessage_2_222: "Upload dokumentation for relation til personen",
  remediationMessage_2_223: "Tilføj 'organization.countryOfGoverningLaw' til juridisk enhed",
  remediationMessage_2_234: "Tilføj 'organization.support.email' til juridisk enhed",
  remediationMessage_2_235: "Tilføj 'individual.support.email' til juridisk enhed",
  remediationMessage_2_236: "Tilføj 'organization.support.phone.number' til juridisk enhed",
  remediationMessage_2_237: "Tilføj 'individual.support.email' til juridisk enhed",
  remediationMessage_3_100: "Tjek ovenstående oplysninger, og klik derefter her for at bekræfte.",
  remove: "Fjern",
  removeDecisionMaker: "fjern %{decisionMaker}",
  removeTrustMember: "Fjern %{trustMember}",
  removing: "Fjerner...",
  rentalAgreementOrLease: "Lejeaftale eller lejekontrakt",
  rentAmount: "Huslejebeløb",
  reportedDividendAmount: "Rapporteret udbyttebeløb",
  reportedValue: "Rapporteret værdi",
  reportingCurrency: "Rapporteringsvaluta",
  requirements: "Krav:",
  requiresDecisionMakers: "Kræver beslutningstagere",
  requiresSignatory: "Kræver underskriver",
  residence_permit: "Opholdstilladelse",
  residencePermitBack: "Opholdstilladelse (bagside)",
  residencePermitFront: "Opholdstilladelse (forside)",
  residencyCountry: "Bopælsland/-område",
  residentialAddress: "Bopælsadresse",
  residentialAddressDescription: "Denne persons primære adresse, som typisk bruges til personlig bankvirksomhed og forsyningsregninger.",
  retrieveMyInfo: "Hent Myinfo",
  retrieveMyInfoBusiness: "Hent Myinfo-virksomhed",
  retrieveMyinfoBusinessWith: "Hent Myinfo-virksomhed med",
  retrieveMyinfoWith: "Hent Myinfo med",
  returnToTaskList: "Gå tilbage til opgavelisten",
  reviewTheInformationBelowAndCorrectMistakesOr: "Gennemgå nedenstående oplysninger, og ret eventuelle fejl, eller",
  RFC: "RFC",
  RfcDocument: "RFC-dokument",
  rnaNumber: "RNA-nummer",
  role: "Rolle",
  roleAndEntityType: "Rolle og enhedstype",
  rootLegalEntityIsEmpty: "Den grundlæggende juridiske enhed har kun minimumsdata (er tom).",
  routingNumber: "Routingnummer",
  routingNumberVisible: "Inkluderer dit routingnummer",
  royaltyAgreement: "Royaltyaftale",
  royaltyAmount: "Royaltybeløb",
  salarySlip: "Lønseddel",
  saleAmount: "Salgsbeløb",
  saleContract: "Salgskontrakt",
  sameAsRegisteredAddress: "Samme som registreret virksomhedsadresse",
  sameNameAsLegalName: "Samme som virksomhedens juridiske navn",
  save: "Gem",
  saveAndGoToOverview: "Gem og gå til oversigt",
  screenshotOfOnlineBankingEnviroment: "Skærmbillede af netbankmiljø",
  search: "Søg",
  searchAddress: "Søg efter adresse",
  secForm10k: "SEC-formular 10-K",
  secretaryOfStateFiling: "Registrering hos Secretary of State",
  secretaryOfStateFiling__PR: "Registrering hos Department of State",
  secretaryOfStateRegDoc: "Registreringsdokument fra Secretary of State",
  secretaryOfStateRegDoc__PR: "Registreringsdokument fra Department of State",
  securelyUseYourBanksWebsite: "Brug sikkert din banks hjemmeside eller mobilapp til at blive bekræftet på få minutter.",
  select: "Vælg",
  selectAllTheRolesThatThisDecisionMakerHolds: "Vælg alle de roller, som denne beslutningstager varetager.",
  selectASourceOfFunding: "Vælg en kilde til finansiering for %{type}",
  selectCountryRegion: "Vælg et land/område",
  selectDocument: "Vælg et dokument",
  selectDocumentType: "Vælg dokumenttype",
  selectOne: "Vælg en",
  selectProvinceOrTerritory: "Vælg en provins eller et område",
  selectSigner: "Vælg underskriver",
  selectState: "Vælg en stat",
  selectTheApplicableRoles: "Vælg den eller de relevante roller",
  selectTheBankToReceivePayouts: "Efter denne side kan du vælge den bank, hvor du vil modtage udbetalingerne.",
  serviceAgreements: "Serviceaftaler",
  serviceAgreementSignedAndDated: "Serviceaftale underskrevet og dateret",
  serviceAgreementSignedSuccessfully: "Serviceaftale er underskrevet",
  serviceAgreementSignFailed: "Underskrivelse af serviceaftalen mislykkedes",
  sessionTimeout: "Sessionen er udløbet",
  settlor: "Betaler",
  settlorExemptionReason: "Begrundelse for stifterfritagelse",
  settlorGuideDescription: "<strong>Stifter</strong> er den fysiske person, der har oprettet forvaltningen. En stifter er også kendt som en grundlægger.",
  setUpYourAccount: "Opret din konto",
  shareholderDocument: "Aktionærdokument",
  showAddressStateCountry: "Viser adresse, stat og bopælsland",
  showDetails: "Vis oplysninger",
  showOnMap: "Vis på kort",
  showsCountryOfBankAccount: "Inkluderer landet/regionen for bankkontoen",
  showsTheNameOfTheCoins: "Viser navnet på mønten/mønterne.",
  showsTheNameOfTheCryptocurrencyExchange: "Viser navnet på kryptovalutaudvekslingen",
  showsYourBusinessName: "Viser din virksomheds navn",
  sign: "Underskriv",
  signAndContinue: "Underskriv og fortsæt",
  signatory: "Underskriver",
  signatoryDescription: "Bemyndiget til at underskrive kontrakter på virksomhedens vegne",
  signatoryGuideDescription: "En <strong>underskriver</strong> har fået bemyndigelse til at underskrive officielle dokumenter på virksomhedens vegne. Normalt er en underskriver også en ejer eller en kontrollerende person.",
  signatureAndDateWithinTheLast12Months: "Underskrift og dato inden for de seneste 12 måneder",
  signed: "Underskrevet",
  signedByOn: "Underskrevet den %{date} af %{signer}",
  signedCopyOfTheWill: "Underskrevet kopi af testamentet",
  signer: "Underskriver",
  signServiceAgreement: "Underskriv serviceaftale",
  SINFormatCA: "XXXXXXXXX",
  singingUpAsCompanyButLooksLikeYouAreAnIndividual: "Du tilmelder dig nu som en virksomhed. Men det ser ud til, at du er en enkeltperson, der bruger din personlige bankkonto til at modtage udbetalinger.",
  singingUpAsIndividualButLooksLikeYouAreACompany: "Du tilmelder dig nu som enkeltperson. Men det ser ud til, at du er en virksomhed, der bruger en erhvervsbankkonto til at modtage udbetalinger.",
  siRegistrationNumber: "Matična številka",
  siret: "SIRET",
  siTaxId: "Identifikacijska številka za DDV (ID za DDV)",
  skRegistrationNumber: "Identifikačné číslo (IČO)",
  skTaxId: "Identifikačné číslo pre daň z pridanej hodnoty (IČ DPH)",
  socialInsuranceNumber: "Socialforsikringsnummer (SIN)",
  socialSecurityNumber: "Socialsikringsnummer (SSN)",
  socialSecurityNumber__placeholder: "123-45-6789",
  sofTypeAdyenLabel: "Transaktioner på denne platform",
  sofTypeAssetsaleLabel: "Ejendomssalg",
  sofTypeBusinessLabel: "Andre virksomhedsindtægter",
  sofTypeCryptocurrencyincomeLabel: "Kryptovaluta",
  sofTypeDividendincomeLabel: "Udbytte",
  sofTypeDonationsLabel: "Gave eller donation",
  sofTypeEmploymentLabel: "Ansættelsesløn",
  sofTypeFinancialaidLabel: "Økonomisk støtte",
  sofTypeGamblingwinningsLabel: "Gambling",
  sofTypeInheritanceLabel: "Arv",
  sofTypeInsurancesettlementLabel: "Forsikringsudbetaling",
  sofTypeLoansLabel: "Lån",
  sofTypePensionincomeLabel: "Pension",
  sofTypeRentalincomeLabel: "Lejeindtægt",
  sofTypeRoyaltyincomeLabel: "Royaltyindtægt",
  sofTypeThirdpartyfundingLabel: "Oplysninger om tredjepartsinvesteringer",
  solePropDetails: "Oplysninger om enkeltmandsvirksomhed",
  soleProprietorDetails: "Oplysninger om enkeltmandsvirksomhed",
  soleProprietorship: "Enkeltmandsvirksomhed",
  soleProprietorshipDetails: "Oplysninger om enkeltmandsvirksomhed",
  someFieldsHaveUnsupportedFormatedUpdateInfoAndResubmit: "Nogle felter har formater, der ikke understøttes. Opdater oplysningerne, og indsend igen.",
  someInformationWillNotBeSaved: "Nogle oplysninger, du tidligere har indtastet, gemmes ikke. ",
  sorryAnErrorOccurred: "Vi beklager, men der opstod en fejl",
  sorryWeCantSetUpAnAccountForYou: "Beklager, vi kan ikke oprette en konto til dig.",
  sortCode: "Registreringsnummer",
  sourceOfFunds: "Kilde til midler",
  sourceOfWinnings: "Kilde til gevinster",
  SSM: "Suruhanjaya Syarikat Malaysia (SSM, det malaysiske selskabsregister)",
  ssn: "SSN",
  SSNFormatUS: "*** — ** — XXXX",
  SSNFormatUS9Digits: "XXXXXXXXX",
  SST: "Salgs- og serviceafgift (Sales and Service Tax, SST)",
  stamregister: "Stamregister erhverv (SE-nummer)",
  start: "Start",
  startANewSessionFromTheSamePlaceYouOriginallyAccessed: "Start en ny session fra det samme sted, som du oprindeligt åbnede denne side.",
  startTypingTheAddress: "Begynd at skrive adressen",
  state: "Stat",
  stateIssuedProofOfIdentityCard: "Statsudstedt identitetskort",
  stateOrProvince: "Stat eller provins",
  stateOrProvince__placeHolder: "Vælg stat eller provins",
  stateOrProvince__placeHolder__US: "Vælg en...",
  stateOrProvince__US__business: "I hvilken stat er din virksomhed registreret?",
  status: "Status",
  "stepsX/YofForm": "Trin %{activeFormIndex}/ %{totalForms} af %{taskNameTranslated}",
  stockExchangeInformation: "Børsoplysninger",
  stockExchangeMIC: "Market identifier code (MIC)",
  stockISIN: "International Securities Identification Number (ISIN)",
  stockISINHelper: "Internationalt værdipapiridentifikationsnummer, som defineret i ISO 10383",
  stockTickerSymbol: "Børskode (ticker)",
  street: "Gade",
  submit: "Indsend",
  submitFailed: "Ikke indsendt",
  submitIdDocumentsAgain: "Indsend ID-dokumenter igen",
  submitReview: "Indsend gennemgang",
  submitReviewOfYourData: "Indsend gennemgang af dine data",
  submitSuccessful: "Indsendt",
  subsidyOrGrantAmount: "Tilskudsbeløb",
  successFullyRemovedDecisionMaker: "Beslutningstager er fjernet",
  successFullyRemovedTrustMember: "Forvaltningsmedlem er fjernet",
  successfullyUpdatedDetails: "Detaljer blev opdateret",
  summary: "Resumé",
  summaryLegalCaption: "Når du indsender denne oversigt, bekræfter du følgende; Jeg bekræfter (på vegne af den virksomhed, som jeg er autoriseret til at repræsentere), at de oplysninger og den dokumentation, der er indsendt under denne KYC-proces, er nøjagtige og opdaterede og dermed korrekt afspejler den aktuelle situation.",
  summaryTaxExemptionLegalCaption_1: "Straks at give Adyen det eller de relevante numre, hvis ovennævnte enhed(er) bliver momsregistrereret, eller hvis der sker ændringer i momsnummeret.",
  summaryTaxExemptionLegalCaption_2: "Hvis et momsnummer ikke er angivet, eller hvis det ikke er gyldigt, forbeholder Adyen sig retten til at tillægge moms som foreskrevet i loven, hvilket muligvis ikke kan modregnes for forhandlerens virksomhed.",
  summaryTaxExemptionLegalCaption_3: "Du er en autoriseret repræsentant og underskriver på vegne af den juridiske enhed, som momsoplysningerne blev givet for.",
  summaryTaxExemptionLegalCaptionTitle: "Du har erklæret, at du er fritaget for moms, derfor accepterer du:",
  supportedFileTypes: "Understøttede filtyper: %{fileTypes}",
  supportingDocuments: "Understøttende dokumentation",
  swiftCode: "SWIFT-kode",
  takeOrUploadAPhoto: "Tag eller upload et foto af et ID-dokument for at gennemføre en hurtig og sikker ID-bekræftelse med vores betroede partner,",
  task: "Opgave",
  taxationDocument: "Afgiftsbilag",
  taxDeclaration: "Skatteindberetning",
  taxDeclarationProperty: "Skatteindberetning",
  taxDocument: "Skattedokument",
  taxDocuments: "Skattedokumenter",
  taxFiling: "Skatteindberetning",
  taxFiling__US: "Skatteindberetning, f.eks. Schedule SE (formular 1040)",
  taxId: "Skatte-ID",
  taxIdAbsenceReason: "Begrundelse for manglende skatte-id",
  taxIdentificationNumber: "Skatteidentifikationsnummer",
  taxIdNumber: "Skatteidentifikationsnummer",
  taxInformationNumber: "Skatteidentifikationsnummer",
  taxInformationNumber__helperText__US: "Dit EIN er angivet på dit brev 147C eller SS-4 bekræftelsesbrev, som du modtog, da du registrerede din virksomhed.",
  taxInformationNumber__HK: "Virksomhedsregistreringsnummer (Business Registration Number , BRN)",
  taxInformationNumber__placeHolder__US: "11-0000000",
  taxInformationNumber__US: "Arbejdsgiver id-nummer (EIN)",
  taxpayerReferenceNumber: "Skatteydernummer",
  taxReferenceNumber: "Skatteregistreringsnummer",
  tellUsMoreAboutTheCryptocurrency: "Fortæl os mere om kryptovaluta-indtjeningen, der vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutTheGamblingProceeds: "Fortæl os mere om gambling-udbetalinger, der vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutTheGiftOrDonationProceeds: "Fortæl os mere om gave- eller donationsudbetalinger, der vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutTheInheritanceProceeds: "Fortæl os mere om arven, der vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutTheInvestors: "Fortæl os mere om de investorer, hvis midler vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutThePreviousBusinessEarnings: "Fortæl os mere om den anden virksomhedsindtjening, der vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutTheProperty: "Fortæl os mere om udbetalingen fra ejendomssalget, der vil blive brugt med vores finansielle produkter.",
  tellUsMoreAboutThisSource: "Fortæl os mere om denne kilde",
  termLengthAndDividendYield: "Løbetid og udbytte",
  textToVerifyAccount: "For at du kan modtage dine udbetalinger, skal vi have en bekræftet bankkonto.",
  the7CharacterIdentifierAssignedToThis: "Den 7-tegns identifikator, der er tildelt denne virksomhed af Sistema di Interscambio (SDI) til elektronisk fakturering i Italien. For eksempel: %{example}",
  theBankAccountHolderMustBeInYourName_: "Bankkontoindehaveren skal være i navnet: <strong>%{name}</strong>",
  theBankAccountHolderMustHaveTheSameNameAsYourCompany_: "Indehaveren af bankkontoen skal have det samme navn som din virksomhed <strong>%{companyName}</strong>.",
  theBrokerageName: "Mæglerens navn",
  theBusinessName: "Virksomhedens navn",
  theCityAndCountryRegion: "Byen og landet/regionen, hvor denne person i øjeblikket befinder sig",
  theCompanyIWorkFor: "Den virksomhed, jeg arbejder for",
  theIdCheckWillBeAutomaticallyValidated: "Med den rigtige registrering bliver ID-kontrollen automatisk bekræftet",
  thenResubmit: "Indsend derefter igen.",
  thereAreDifferencesBetweenYourEntryAndWhatWeDetectedInYourIdDocument: "Der er forskelle mellem din indtastning og det, vi registrerede i dit ID-dokument. Vælg de korrekte oplysninger for at fortsætte.",
  thereAreNoSigners: "Der er ingen underskrivere, så tilføj dig selv for at være sikker på, at du kan acceptere betingelserne og få pengene.",
  thereWasAnErrorTryAgain: "Der opstod en fejl, prøv igen",
  thirdPartyInvestmentDetails: "Oplysninger om tredjepartsinvesteringer",
  thisCompanyDoesntHaveAnSDI: "Denne virksomhed har ikke en SDI-kode",
  thisIsMyBusiness: "Dette er min virksomhed",
  thisMeansYouHaveAnUltimateParentCompany: "Hvis ja, betyder det, at du har et ultimativt moderselskab. Et ultimativt moderselskab er det selskab, der er højest i virksomhedsstrukturen. Læs mere.",
  thisMeansYouHaveAParentCompany: "Hvis ja, betyder det, at du har et moderselskab, f.eks. et globalt hovedkvarter eller et holdingselskab.",
  thisPageIsNowInactive: "Denne side er nu inaktiv",
  thisSessionWillExpireIn: "Denne session udløber om %{timeUntilExpiry}. Fortsæt arbejdet for at undgå at miste ikke-gemte data.",
  timePeriodIfApplicable: "Tidsperiode (hvis relevant)",
  titleDeed: "Skøde",
  toCompleteProcessReviewAndSignOfficialDocumentation: "For at fuldføre denne proces skal du gennemgå og underskrive den officielle dokumentation.",
  toggleAssociationMenu: "skifte menu for %{name} ",
  toHelpTheGovernmentFight: "For at hjælpe regeringen med at bekæmpe finansiering af terrorisme og hvidvaskning af penge kræver føderal lovgivning, at finansielle institutioner indhenter, kontrollerer og registrerer oplysninger, der identificerer hver person (privatperson eller enhed), der åbner en konto, og visse personer, der er tilknyttet en konto.",
  tooManyFiles: "For mange filer",
  toProtectYourInformationThisSessionHasExpired: "For at beskytte dine oplysninger er denne session udløbet, og siden er nu inaktiv. Start en ny session fra det samme sted, som du oprindeligt åbnede denne side.",
  totalAmountWon: "Samlet vundet beløb",
  totalAssets: "Aktiver i alt",
  totalAssetsHelper: "Summen af samlede forpligtelser og egenkapital",
  totalSettlementAmount: "Samlet afregningsbeløb",
  tradingName: "Handelsnavn",
  transactionStatement: "Transaktionsopgørelse",
  transferInstrumentDeleted: "Overførselsinstrument slettet",
  transferInstrumentLimitHasAlreadyBeenMet: "Begrænsningen for overførselsinstrumentet er allerede nået",
  transitNumber: "Transitnummer",
  trust: "Forvaltning",
  trustDeed: "Forvaltningsdokument",
  trustDetails: "Forvaltningsoplysninger",
  trustDetailsDescription: "For at forberede din konto skal vi bruge oplysninger om din virksomhed.",
  trustee: "Tillidshaver",
  trusteeAsTrusteeForTrust: "%{trusteeName} som tillidshaver for %{trustName}",
  trusteeAsTrusteeForTrustDoingBusinessAs: "%{trusteeName} som tillidshaver for %{trustName}, der driver virksomhed som %{tradingName}",
  trusteeGuideDescription: "<strong>Tillidshaver</strong> er en fysisk person eller en juridisk person, der kan administrere, anvende eller disponere over forvaltningens aktiver.",
  trusteePersonalDetails: "Tillidshavers personlige oplysninger",
  trustInstrument: "Stiftelsesdokumentet",
  trustMembers: "Forvaltningsmedlemmer",
  trustMembersDescription: "Angiv oplysninger om alle tillidshaver, stifter, protektor og modtager i forbindelse med forvaltningskontrakt.",
  trustPartnershipOrAssociation: "Forvaltning, partnerskab eller forening",
  trustType: "Type af forvaltningsaftale",
  tryAgain: "Prøv igen",
  tryAgainOrContinueEnteringTheDetailsYourself: "Prøv igen, eller fortsæt ved at indtaste detaljerne selv.",
  tryAgainOrManualAccountDetails: "Prøv igen senere, eller angiv kontooplysningerne manuelt.",
  typeOfCompany: "Virksomhedstype",
  typeOfIdentity: "Type af identitet",
  typeOfIdentitySubtitle: "Vi skal se et billedlegitimationsdokument udstedt af en offentlig myndighed, som tilhører den ovennævnte person.",
  typeOfTrustAgreement: "Type af forvaltningsaftale",
  uboThroughControlGuideDescription: "<strong>Den ultimative ejer (UBO) gennem kontrol</strong> er enhver anden person, der kontrollerer forvaltningen og kan træffe finansielle og driftsmæssige beslutninger på forvaltningens vegne.",
  uboThroughOwnershipGuideDescription: "<strong>Den ultimative ejer (UBO) gennem ejerskab</strong> er en person, der direkte eller indirekte ejer 25 % eller mere af de samlede aktier, stemmerettigheder eller anden egenkapital i organisationen.",
  uen: "Unique Entity Number (UEN)",
  ultimateParentCompany: "Ultimativt moderselskab",
  ultimateParentCompanyInformation: "Oplysninger om det ultimative moderselskab",
  unableToDeleteDocument: "Kan ikke slette dokumentet",
  unableToUploadDocument: "Kan ikke uploade dokumentet",
  unableToVerifyTheIdNumber: "Kan ikke bekræfte id-nummeret for det givne land",
  undefinedBeneficiary: "Udefineret modtager",
  undefinedBeneficiaryDescription: "En klasse eller gruppe af modtagere, der ikke er nævnt, men defineret på en bestemt måde i forvaltningsdokumentet.",
  underJudicialAdministration: "Ja, virksomheden er under administration, konkursbehandling eller lignende foranstaltninger",
  undoWithTimer: "Fortryd... %{secondsLeft}",
  unfortunatelyAnInstantProvider: "Desværre er en øjeblikkelig udbyder ikke tilgængelig for dette land.",
  unincorporatedDetails: "Oplysninger om partnerskab uden juridisk person",
  unincorporatedPartnershipType: "Type af partnerskab uden juridisk person",
  uniqueIdentificationCode: "ЕИК, Unique Identification Code (ЕИК/UIC)",
  unknown: "Ukendt",
  unlistedPublicUnitTrust: "Forvaltning af ikke-børsnoteret offentlig enhed",
  unsuccessful: "Mislykket",
  unsupportedFiletype: "Filetypen understøttes ikke",
  update: "Opdater",
  updateTheInformation: "Opdater oplysningerne",
  uploadABankStatement: "Upload et kontoudtog",
  uploadADocument: "Upload et dokument",
  uploadASupportingDocument: "Upload et understøttende dokument",
  uploadDocumentForNric: "Upload et ID-dokument i stedet for NRIC",
  uploadedOn: "Uploadet den %{date}",
  uploadOneOfTheseDocuments: "Upload et af disse dokumenter:",
  uploadTheFollowingDocuments: "Upload følgende dokumenter:",
  uploadYourOrganizationProofOfDirector: "Upload et bevis for din organisations direktør",
  upToFiles: "Op til %{maxFiles} fil(er).",
  useFiguresFromTheMostRecentYearAvailable: "Brug tal fra det seneste år, der er tilgængeligt",
  usePhoneToScanId: "Brug din telefon til at scanne ID'et",
  useSelectedInformation: "Anvend valgte oplysninger",
  "UST-ID": "UST-ID (Umsatzsteuer-Identifikationsnummer)",
  "USt-IdNr": "USt-IdNr. (Umsatzsteuer-Identifikationsnummer)",
  utilityBill: "Forsyningsregning (el, vand, gas)",
  validation8Or11Characters: "Indtast enten 8 eller 11 tegn.",
  validationCharacters: "Indtast %{length} tegn.",
  validationDigits: "Indtast %{length} cifre",
  validationDigitsBetween: "Indtast et tal med mellem %{start} og %{end} cifre",
  validationPleaseEnterAValidBusinessRegistrationNumberWithFormat: "Indtast et gyldigt virksomhedsregistreringsnummer. For eksempel: %{example} ",
  validationPleaseEnterAValidEINWithFormat: "Indtast et gyldigt EIN-nummer. Forventet format: %{format}",
  validationPleaseEnterAValidIban: "Indtast et gyldigt IBAN-nummer",
  validationPleaseEnterAValidIdNumberWithFormat: "Indtast et gyldigt %{idType}-nummer. Forventet format: %{format}",
  validationPleaseEnterAValidIRDNumber: "Indtast et gyldigt telefonnummer. Forventet format: 8 - 9 cifre",
  validationPleaseEnterAValidMarketIdentifier: "Indtast en gyldig markedsidentifikationskode",
  validationPleaseEnterAValidRegistrationNumber: "Indtast et gyldigt virksomhedsregistreringsnummer",
  validationPleaseEnterAValidRegistrationNumberWithFormat: "Indtast et gyldigt virksomhedsregistreringsnummer Forventet format: %{format}",
  validationPleaseEnterAValidStockISIN: "Indtast et gyldigt ISIN-nummer. For eksempel: %{example}",
  validationPleaseEnterAValidTaxIdNumber: "Indtast et gyldigt skatte-id-nummer.",
  validationPleaseEnterAValidTaxIdNumberWithFormat: "Indtast et gyldigt skatte-id-nummer. Forventet format: %{format}",
  validationPleaseEnterAValidUen: "Indtast et gyldigt UEN",
  validationPleaseEnterAValidUrl: "Indtast en gyldig URL",
  validationPleaseEnterAValidVatNumber: "Indtast et gyldigt skatte-id-nummer",
  validationPleaseEnterAValidVatNumberWithFormat: "Indtast et gyldigt momsnummer. Forventet format: %{format}",
  vatAbsenceReason: "Årsag til manglende momsnummer",
  vatDocument: "Momsdokument",
  vatNumber: "Momsnummer",
  vatNummerMomsregistreringsnummerOrMomsnummer: "VAT-nummer, momsregistreringsnummer eller momsnummer",
  vatRegistrationNumber: "Momsregistreringsnummer",
  verificationErrorMessage: "Nogle oplysninger kunne ikke bekræftes. Klik for at se, hvad der skal justeres.",
  verificationMethod: "Bekræftelsesmetode",
  verified: "Bekræftet",
  verifiedInformation: "Bekræftede oplysninger",
  verify: "Bekræft",
  verifyIndividualIdentity: "Bekræft identitet for %{name}",
  verifyViaMobileBankingAppOrWebsite: "Bekræft via mobilbankapp eller hjemmeside",
  verifyWith: "Bekræft via",
  weAccept: "Vi accepterer:",
  website: "Hjemmeside",
  weCouldNotReachOnfido: "Vi kunne ikke få kontakt til Onfido. Prøv igen om nogle sekunder.",
  weCouldntCompleteTheAccountCheck: "Vi kunne ikke fuldføre kontokontrollen. Prøv igen senere, eller angiv kontooplysningerne manuelt.",
  weCouldntConnectToMyinfo: "Vi kunne ikke oprette forbindelse til Myinfo",
  weCouldntConnectToMyinfoBusiness: "Vi kunne ikke oprette forbindelse til Myinfo Business",
  weDoNotYetSupportInstantVerificationForBankAccountsIn_: "Vi understøtter endnu ikke øjeblikkelig kontobekræftelse i %{countryName}. Derfor skal du angive dine kontooplysninger manuelt.",
  weFoundTheFollowingIssues: "Vi fandt følgende problemer:",
  weNeedAnOfficialDocument: "Vi har brug for et officielt dokument til at verificere din organisations direktør. ",
  weNeedProofOfFunding: "Vi har brug for dokumentation for finansieringskilder til %{category_name}. Dette hjælper os med bedre at forstå, hvordan du vil bruge disse produkter.",
  weNeedProofOfFundingPlural: "Vi har brug for bevis for finansieringskilder til %{category1_name} og %{category2_name}. Dette hjælper os med bedre at forstå, hvordan du vil bruge disse produkter.",
  weSelectedSomeRolesBasedOnMyinfoBusinessDataAboutYourCompanysAppointmentHoldersAndShareholders: "Vi har udvalgt nogle roller baseret på Myinfos forretningsdata om din virksomheds indehavere og aktionærer.",
  whatBestDescribesYourBusinessSetup: "Hvad beskriver bedst din virksomhedsform?",
  whatCountryOrRegionIsTheBenefactorLocated: "Hvilket land/område er velgøren placeret?",
  whatCountryOrRegionIsThisPersonLocated: "Hvilket land/område befinder denne person sig i?",
  whatFinancialProductIsThisFor: "Hvilket finansielt produkt er dette til?",
  whatIsTheDifferenceBetweenTheseRoles: "Hvad er forskellen mellem disse roller?",
  whatTypeOfCompanyDoYouHave: "Hvilken type virksomhed har du?",
  whatTypeOfOPartnershipAreYou: "Hvilken type partnerskab uden juridisk person er du?",
  whatTypeOfTrusteeAreYou: "Hvilken type tillidshaver er du?",
  whatTypeOfYourMembersEntity: "Hvad er typen af din medlemsenhed?",
  whereCanIFindTheseNumbersOnMyDriversLicense: "Hvor kan jeg finde disse tal på mit kørekort?",
  whereDidThisGiftOrDonationComeFrom: "Hvor stammer denne gave eller donation fra?",
  whereDidThisInheritanceComeFrom: "Hvor stammer denne arv fra?",
  whereToFindNumbersOnDriversLicense: "Afhængigt af udstedelsesstaten kan placeringen af disse tal variere, men licensnummeret er altid på forsiden af kortet, og kortnummeret er i de fleste tilfælde placeret på bagsiden.",
  whereToFindNumbersOnDriversLicense__NZ: "Licens- og versionsnummeret står altid på forsiden af kortet.",
  whichLegalArrangementDoesYourBusinessHave: "Hvilken juridisk ordning har din virksomhed?",
  whichOfTheseApplyToTheSettlor: "Hvilke af disse gælder for stifteren? Vælg alt, hvad der er relevant.",
  whichTypeOfIdNumberDoYouHave: "Hvilken type identifikationsnummer har du?",
  whichTypeOfRegistrationNumberDoYouHave: "Hvilken type registreringsnummer har du?",
  whichTypeOfTaxIdNumberDoYouHave: "Hvilken type skatteidentifikationsnummer har du?",
  whyDoINeedToFillInThisInformation: "Hvorfor skal jeg udfylde disse oplysninger?",
  winLossStatement: "Gevinst/tab opgørelse",
  winningProceedAmount: "Gevinstoverskud",
  winReport: "Gevinstrapport",
  wouldYouLikeToSignUpAsCompanyInstead: "Kunne du tænke dig at tilmelde dig som virksomhed i stedet? (Du skal genindtaste nogle af oplysningerne fra før).",
  wouldYouLikeToSignUpAsIndividualInstead: "Vil du tilmelde dig som enkeltperson i stedet? (Du skal genindtaste nogle af oplysningerne fra før).",
  xCharactersLeft: "%{charactersLeft} tegn tilbage",
  xMinutes: "%{minutes} minutter",
  xMinutesAndYSeconds: "%{minutes} og %{seconds}",
  XOfYSteps: "%{currentStep} af %{totalSteps} ",
  xSeconds: "%{seconds} sekunder",
  yes: "Ja",
  yesAddManually: "Ja, tilføj manuelt",
  yesChange: "Ja, skift",
  yesContinue: "Ja, fortsæt",
  youAlsoHaveToUploadSomeSupportingDocuments: "Du skal også uploade nogle understøttende dokumenter.",
  youAreIndividualOrCompanyAndUseBankAccountInNameOfPartnershipOrAssociation: "Du er en enkeltperson eller en virksomhed, og du bruger en bankkonto i et partnerskabs eller en forenings navn.",
  youAreIndividualOrCompanyAndUseBankAccountInNameOfTrustPartnershipOrAssociation: "Du er en enkeltperson eller en virksomhed, og du bruger en bankkonto i en forvaltnings, et partnerskabs eller en forenings navn.",
  youAreNotSoleProprietorAndUseBankAccount: "Du er ikke en registreret enkeltmandsvirksomhed, og du bruger en bankkonto i dit navn.",
  youAreRegisteredSoleProprietorAndUseBankAccount: "Du er en registreret enkeltmandsvirksomhed, og du bruger en bankkonto i dit navn eller enkeltmandsvirksomhedens navn.",
  youAreTrusteeManagingTheTrustForBeneficiaries: "Du er en tillidshaver, der administrerer forvaltningen for de begunstigede.",
  youCanOnlyUseABankAccountInTheCountryRegionWhereYouLive: "Du kan kun bruge en bankkonto i det land/område, hvor du bor.",
  youCanOnlyUseABankAccountInTheCountryRegionWhereYourCompanyIsRegistered: "Du kan kun bruge en bankkonto i det land/område, hvor din virksomhed er registreret.",
  youHaveSuccessfullyProvidedTheIdDocument: "Indsendelse af ID-dokumentet lykkedes.",
  youMayBeAskedToReUpload: "Du kan blive bedt om at uploade et andet ID-dokument igen i fremtiden.",
  youMustXYearsOldToContinue: "Du skal være mindst %{minimumAge} år gammel for at fortsætte",
  yourAssociationIsRegisteredItWasSetUpForNonCommercialPurpose: "Din forening er registreret. Det blev oprettet til rekreative, kulturelle eller nonprofitformål.",
  yourBankWillConfirmYourAccountDetails: "Din bank bekræfter dine kontooplysninger over for os.",
  yourBusiness: "Din virksomhed",
  yourBusinessInformation: "Dine virksomhedsoplysninger",
  yourBusinessIsRegisteredAsASeparateLegalEntityFromItsOwners: "Din virksomhed er registreret som en separat juridisk enhed fra sine ejere.",
  yourBusinessName: "Din virksomheds navn",
  yourBusinesssDetailsArePreFilledInTheRelevantSections: "Dine virksomhedsoplysninger er forudfyldt i de relevante sektioner.",
  yourBusinessSetup: "Din virksomhedsform: %{businessSetup}",
  yourDetailsArePreFilledInTheRelevantSections: "Dine oplysninger er forudfyldt i de relevante sektioner.",
  yourFullName: "Dit fulde navn",
  yourIbanShouldBeginWith_: "Dit IBAN skal begynde med %{countryCode}.",
  yourLoanApplicationHasBeenReceived: "Tak for dine supplerende oplysninger. De leverede data er ved at blive gennemgået. Du får besked, hvis der er behov for andet.",
  yourName: "Dit navn",
  yourRelationshipToDecedent: "Din relation til afdøde",
  yourRelationshipToDonor: "Din relation til donoren",
  yourRelationshipToOrganization: "Din tilknytning til organisationen",
  yourRelationshipToThisPerson: "Din relation til denne person",
  youSuccessfullyVerifiedAccount: "Du har bekræftet din bankkonto.",
  YTunnus: "Y-TUNNUS",
  zentralesVereinsregisterId: "Zentrales Vereinsregister ID",
  zipCode: "Postnummer"
};
export {
  daDK as default
};
